/* ================================================================
   ww-pdp.js  v11
   FBT: color filtering by size (same as main product)
   FBT: OOS guard before add — matches variant, errors if none
   Cart: monster_addToCart integration (Monster Upsells)
   Modal: inline Liquid content (no iframe — Shopify blocks those)
   ================================================================ */

(function () {
  'use strict';

  var wwFbtSelected  = { coupler: {}, ball: {}, treats: {} };
  var wwAddedItems   = new Set();
  var selectedOptions = {};
  var RING_ON  = '0 0 0 2px #fff, 0 0 0 3.5px #1A1A18';
  var RING_OFF = 'inset 0 0 0 1px rgba(0,0,0,0.18), 0 1px 3px rgba(0,0,0,0.1)';

  /* ─────────────────────────────────────────
     COLOR FILTERING UTILITY
  ───────────────────────────────────────── */
  function wwFilterColors(swatchContainer, variants, selectedSizeValue) {
    if (!swatchContainer || !variants) return;
    swatchContainer.querySelectorAll('button[data-value]').forEach(function(btn) {
      var colorValue = btn.dataset.value;
      var isAvailable;
      if (!selectedSizeValue) {
        isAvailable = variants.some(function(v) {
          return v.available && v.options.indexOf(colorValue) !== -1;
        });
      } else {
        isAvailable = variants.some(function(v) {
          return v.available
            && v.options.indexOf(selectedSizeValue) !== -1
            && v.options.indexOf(colorValue) !== -1;
        });
      }
      btn.style.display = isAvailable ? '' : 'none';
    });
  }

  /* ─────────────────────────────────────────
     CART COUNT BADGE UPDATE
  ───────────────────────────────────────── */
  function wwUpdateCartBadge() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count || 0;
        [
          '[data-cart-count]', '[data-cart-item-count]',
          '.cart-count-bubble span', '.cart-count',
          '.cart__count', '#CartCount', '.js-cart-count'
        ].forEach(function(sel) {
          document.querySelectorAll(sel).forEach(function(el) {
            if (/^\d*$/.test(el.textContent.trim())) el.textContent = count;
          });
        });
        var bubble = document.querySelector('.cart-count-bubble');
        if (bubble) bubble.style.display = count > 0 ? '' : 'none';
      })
      .catch(function() {});
  }

  /* ─────────────────────────────────────────
     GALLERY — WUNDERball-pattern slide toggle.
     Thumb click/keypress → swaps which .ww-main-slide has .active.
     Works on mobile touch because the click listener is bound
     declaratively via onclick="wwSetImg(this)" in the template.
     Backward-compat: if slides aren't present (legacy template),
     falls back to src-swap on #ww-main-img.
  ───────────────────────────────────────── */
  function wwActivateThumb(thumb) {
    var wrap = thumb.closest('.ww-gallery') || document;
    // Flip active on all thumbs in this gallery
    wrap.querySelectorAll('.ww-thumb').forEach(function(t) {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    thumb.classList.add('active');
    thumb.setAttribute('aria-selected', 'true');

    var idx = thumb.getAttribute('data-target');
    var slides = wrap.querySelectorAll('.ww-main-slide');
    if (idx != null && slides.length) {
      // Multi-slide gallery — toggle .active on matching slide
      slides.forEach(function(s) {
        s.classList.toggle('active', s.getAttribute('data-slide') === idx);
      });
    } else if (thumb.dataset.src) {
      // Fallback: legacy single-image template — swap src
      var img = wrap.querySelector('#ww-main-img') || document.getElementById('ww-main-img');
      if (img) img.src = thumb.dataset.src;
    }

    // Keep the active thumb visible in the scroller (for >5 thumb row)
    if (thumb.scrollIntoView) {
      try { thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
      catch (e) {}
    }
  }
  window.wwSetImg = function (thumb) { wwActivateThumb(thumb); };

  // Keyboard support — Enter/Space on a thumb activates it.
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = e.target && e.target.closest && e.target.closest('.ww-thumb');
    if (!t) return;
    e.preventDefault();
    wwActivateThumb(t);
  });

  /* ─────────────────────────────────────────
     MAIN PRODUCT — COLOR SWATCH
  ───────────────────────────────────────── */
  window.wwSelectColor = function (btn, value, sectionId) {
    var row = btn.closest('.ww-color-row') || btn.parentElement;
    row.querySelectorAll('button.ww-c-dot').forEach(function(b) {
      b.style.boxShadow = RING_OFF;
      b.style.transform = 'scale(1)';
    });
    btn.style.boxShadow = RING_ON;
    btn.style.transform = 'scale(1.12)';

    var nameEl = document.getElementById('ww-color-name-' + sectionId);
    if (nameEl) nameEl.textContent = '\u2014 ' + value;

    if (!selectedOptions[sectionId]) selectedOptions[sectionId] = {};
    selectedOptions[sectionId][btn.dataset.option] = value;

    wwSwapImageForColor(sectionId, value);
    wwSyncVariant(sectionId);
  };

  function wwSwapImageForColor(sectionId, colorValue) {
    var pool = window.wwVariantData && window.wwVariantData[sectionId];
    if (!pool) return;
    var mainImg = document.getElementById('ww-main-img');
    if (!mainImg) return;

    var match = null;
    for (var i = 0; i < pool.length; i++) {
      var v = pool[i];
      if (v.options.indexOf(colorValue) !== -1 && v.featured_image && v.featured_image.src) {
        match = v; break;
      }
    }
    if (!match) return;

    var src = match.featured_image.src.split('?')[0];
    src = src.replace(/(\.\w+)$/, '_1200x$1');

    // Swap the src on the first slide's image AND force slide 0 active so
    // the color change is visible even if the shopper had navigated to a
    // non-first slide. Matches the multi-slide gallery pattern.
    mainImg.style.opacity = '0.6';
    mainImg.src = src;
    mainImg.onload = function() { mainImg.style.opacity = '1'; };

    document.querySelectorAll('.ww-main-slide').forEach(function(s) {
      s.classList.toggle('active', s.getAttribute('data-slide') === '0');
    });

    // Best-effort: find the thumb whose image matches this variant's
    // featured image filename stem and mark it active. If the match
    // fails (e.g. color variants share an image), fall back to the first.
    var stem = match.featured_image.src.split('?')[0].split('/').pop().split('_')[0];
    var matched = false;
    document.querySelectorAll('.ww-thumb').forEach(function(thumb) {
      var tImg = thumb.querySelector('img');
      if (tImg && tImg.src.indexOf(stem) !== -1 && !matched) {
        document.querySelectorAll('.ww-thumb').forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.classList.add('active');
        thumb.setAttribute('aria-selected', 'true');
        matched = true;
      }
    });
    if (!matched) {
      var thumbs = document.querySelectorAll('.ww-thumb');
      if (thumbs.length) {
        thumbs.forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        thumbs[0].classList.add('active');
        thumbs[0].setAttribute('aria-selected', 'true');
      }
    }
  }

  /* ─────────────────────────────────────────
     MAIN PRODUCT — SIZE BUTTON
  ───────────────────────────────────────── */
  window.wwSelectSize = function (btn) {
    var sectionId = btn.dataset.section;
    var grid = btn.closest('.ww-size-grid');
    if (grid) grid.querySelectorAll('.ww-size-btn').forEach(function(b) { b.classList.remove('sel'); });
    btn.classList.add('sel');

    if (!selectedOptions[sectionId]) selectedOptions[sectionId] = {};
    selectedOptions[sectionId][btn.dataset.option] = btn.dataset.value;

    var variants = window.wwVariantData && window.wwVariantData[sectionId];
    var row = document.getElementById('ww-color-row-' + sectionId);
    if (row && variants) {
      wwFilterColors(row, variants, btn.dataset.value);
      var selDot = row.querySelector('button.ww-c-dot[style*="3.5px"]');
      if (selDot && selDot.style.display === 'none') {
        var firstVisible = Array.from(row.querySelectorAll('button.ww-c-dot'))
          .find(function(b) { return b.style.display !== 'none'; });
        if (firstVisible) wwSelectColor(firstVisible, firstVisible.dataset.value, sectionId);
      }
    }
    wwSyncVariant(sectionId);
  };

  /* ─────────────────────────────────────────
     MAIN PRODUCT — VARIANT SYNC
  ───────────────────────────────────────── */
  function wwSyncVariant(sectionId) {
    var pool = window.wwVariantData && window.wwVariantData[sectionId];
    if (!pool) return;
    var sel = selectedOptions[sectionId] || {};
    var matched = null;
    for (var i = 0; i < pool.length; i++) {
      var v = pool[i]; var ok = true;
      for (var pos in sel) {
        if (v.options[parseInt(pos, 10) - 1] !== sel[pos]) { ok = false; break; }
      }
      if (ok) { matched = v; break; }
    }
    if (!matched) return;

    var native = document.getElementById('ww-variant-select-' + sectionId);
    if (native) { native.value = matched.id; native.dispatchEvent(new Event('change', { bubbles: true })); }
    var hidden = document.getElementById('ww-variant-id-' + sectionId);
    if (hidden) hidden.value = matched.id;

    var cta = document.getElementById('ww-add-to-cart-' + sectionId);
    if (cta) {
      if (matched.available) {
        cta.disabled = false; cta.classList.remove('ww-cta-oos');
        cta.textContent = 'Add to Cart \u2014 ' + wwMoney(matched.price);
      } else {
        cta.disabled = true; cta.classList.add('ww-cta-oos');
        cta.textContent = 'Out of Stock';
      }
    }
    var pw = document.getElementById('ww-price-' + sectionId);
    if (pw) {
      var s = pw.querySelector('.ww-sale-price');
      var o = pw.querySelector('.ww-orig-price');
      var p = pw.querySelector('.ww-save-pill');
      var n = pw.querySelector('.ww-price-note');
      if (s) s.textContent = wwMoney(matched.price);
      if (matched.compare_at_price && matched.compare_at_price > matched.price) {
        if (o) { o.textContent = wwMoney(matched.compare_at_price); o.style.display = ''; }
        if (p) { p.textContent = 'Save ' + Math.round((matched.compare_at_price - matched.price) * 100 / matched.compare_at_price) + '%'; p.style.display = ''; }
      } else {
        if (o) o.style.display = 'none';
        if (p) p.style.display = 'none';
      }
      if (n) n.innerHTML = 'or 4 interest-free payments of <b>' + wwMoney(Math.round(matched.price / 4)) + '</b> with Shop Pay';
    }
    var sc = document.getElementById('ww-scarcity-' + sectionId);
    if (sc) {
      if (matched.inventory_quantity > 0 && matched.inventory_quantity < 15) {
        sc.style.display = 'flex';
        sc.innerHTML = '<span class="ww-pulse-dot"></span>Only ' + matched.inventory_quantity + ' left in ' + matched.title + ' \u2014 order soon';
      } else sc.style.display = 'none';
    }
  }

  function wwMoney(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  /* ─────────────────────────────────────────
     FBT — SIZE LABEL SHORTENER
     Variant labels like "SMALL: 6-15 lbs. (each dog)" or "(LARGE) up to
     80 lbs." are too long to fit in a single picker row. This helper
     returns a compact display label (XL / L / M / S / XS) while the
     full label is preserved for the tooltip and the underlying variant
     value stays untouched (so cart, orders, and inventory all still use
     the real variant name). Non-size options (flavors, etc.) and values
     that don't contain a known size pattern fall through unchanged.
  ───────────────────────────────────────── */
  function wwShortSize(val) {
    if (!val) return String(val || '');
    var s = String(val).toUpperCase();
    if (s.indexOf('XL') !== -1 || s.indexOf('EXTRA LARGE') !== -1 || s.indexOf('EXTRA-LARGE') !== -1) return 'XL';
    if (s.indexOf('XS') !== -1 || s.indexOf('EXTRA SMALL') !== -1 || s.indexOf('EXTRA-SMALL') !== -1) return 'XS';
    if (/\bLARGE\b/.test(s))  return 'L';
    if (/\bMEDIUM\b/.test(s) || /\bMED\b/.test(s)) return 'M';
    if (/\bSMALL\b/.test(s))  return 'S';
    return val;
  }

  function wwEscapeAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ─────────────────────────────────────────
     FBT — BUILD INLINE PICKER
  ───────────────────────────────────────── */
  window.wwFbtExpand = function (key, addBtn) {
    var picker   = document.getElementById('ww-fbt-picker-' + key);
    var optWrap  = document.getElementById('ww-fbt-options-' + key);
    var options  = window.wwFbtOptions  && window.wwFbtOptions[key];
    var variants = window.wwFbtProducts && window.wwFbtProducts[key];
    if (!picker || !optWrap || !options) return;
    if (addBtn) addBtn.style.display = 'none';

    if (!optWrap.dataset.built) {
      var html = '';
      options.forEach(function(opt) {
        var isColor = opt.name === 'Color' || opt.name === 'Colour';
        var isSizeLbl = opt.name === 'Size' || opt.name === 'size';
        html += '<div class="ww-fbt-opt-group">';
        html += '<div class="ww-fbt-opt-label" id="ww-fbt-lbl-' + key + '-' + opt.name + '">'
          + opt.name.toUpperCase();
        if (isColor) html += '<span class="ww-fbt-color-lbl" id="ww-fbt-clbl-' + key + '"></span>';
        // Size label — populated with the full variant value (e.g. "LARGE
        // (up to 80 lbs)") the moment a shopper clicks a size pill. Pills
        // themselves only show the short letter (L/M/S/XL) to keep them on
        // one row; this span is how the weight/size detail stays visible.
        if (isSizeLbl) html += '<span class="ww-fbt-size-lbl" id="ww-fbt-slbl-' + key + '"></span>';
        html += '</div><div class="ww-fbt-opt-values" id="ww-fbt-vals-' + key + '-' + opt.name + '">';

        opt.values.forEach(function(val) {
          var hasAny = variants && variants.some(function(v) {
            return v.available && v.options.indexOf(val) !== -1;
          });
          if (!hasAny) return;

          if (isColor) {
            var isSwirl = val === 'Swirl';
            var hex = wwColorHex(val);
            html += '<button type="button" class="ww-fbt-swatch"'
              + ' data-key="' + key + '"'
              + ' data-option="' + opt.name + '"'
              + ' data-value="' + val + '"'
              + ' title="' + val + '"'
              + ' onclick="wwFbtPickOption(this)"'
              + (isSwirl
                ? ' style="background:conic-gradient(#E8622A,#F4C430,#5A9E6F,#4A90C4,#8B5EA4,#D966A0,#E8622A);"'
                : ' style="background-color:' + hex + ';"')
              + '></button>';
          } else {
            // Size pills: show short letter (L / M / S / XL / XS) for a
            // clean one-row layout; keep full label as title + data-value
            // so the cart and underlying variant identity are unchanged.
            var isSize = opt.name === 'Size' || opt.name === 'size';
            var displayLabel = isSize ? wwShortSize(val) : val;
            html += '<button type="button" class="ww-fbt-pill"'
              + ' data-key="' + key + '"'
              + ' data-option="' + wwEscapeAttr(opt.name) + '"'
              + ' data-value="' + wwEscapeAttr(val) + '"'
              + ' title="' + wwEscapeAttr(val) + '"'
              + ' aria-label="' + wwEscapeAttr(val) + '"'
              + ' onclick="wwFbtPickOption(this)"'
              + '>' + wwEscapeAttr(displayLabel) + '</button>';
          }
        });

        html += '</div></div>';
      });

      optWrap.innerHTML = html;
      optWrap.dataset.built = '1';
    }

    picker.style.display = 'block';
  };

  /* ─────────────────────────────────────────
     FBT — OPTION PICK
  ───────────────────────────────────────── */
  window.wwFbtPickOption = function (btn) {
    var key    = btn.dataset.key;
    var option = btn.dataset.option;
    var value  = btn.dataset.value;
    var group  = btn.closest('.ww-fbt-opt-values');

    if (group) group.querySelectorAll('button').forEach(function(b) { b.classList.remove('sel'); });
    btn.classList.add('sel');

    if (!wwFbtSelected[key]) wwFbtSelected[key] = {};
    wwFbtSelected[key][option] = value;

    var variants = window.wwFbtProducts && window.wwFbtProducts[key];
    var options  = window.wwFbtOptions  && window.wwFbtOptions[key];

    var isSize = option !== 'Color' && option !== 'Colour';
    if (isSize && variants && options) {
      var colorOptName = null;
      options.forEach(function(o) {
        if (o.name === 'Color' || o.name === 'Colour') colorOptName = o.name;
      });
      if (colorOptName) {
        var colorValContainer = document.getElementById('ww-fbt-vals-' + key + '-' + colorOptName);
        if (colorValContainer) {
          wwFilterColors(colorValContainer, variants, value);
          var selColor = colorValContainer.querySelector('button.ww-fbt-swatch.sel');
          if (selColor && selColor.style.display === 'none') {
            selColor.classList.remove('sel');
            delete wwFbtSelected[key][colorOptName];
            var clbl = document.getElementById('ww-fbt-clbl-' + key);
            if (clbl) clbl.textContent = '';
          }
        }
      }
    }

    if (option === 'Color' || option === 'Colour') {
      var clbl = document.getElementById('ww-fbt-clbl-' + key);
      if (clbl) clbl.textContent = ' \u2014 ' + value;
    }

    // When a size is picked, reveal the full variant label (which carries the
    // weight info — "LARGE (up to 80 lbs)") next to the SIZE heading. The
    // pill itself still shows just "L" to keep all sizes on one row.
    if (option === 'Size' || option === 'size') {
      var slbl = document.getElementById('ww-fbt-slbl-' + key);
      if (slbl) slbl.textContent = ' \u2014 ' + value;
    }
  };

  /* ─────────────────────────────────────────
     FBT — ADD SELECTED VARIANT
  ───────────────────────────────────────── */
  window.wwFbtAddSelected = function (key, btn) {
    var variants = window.wwFbtProducts && window.wwFbtProducts[key];
    var options  = window.wwFbtOptions  && window.wwFbtOptions[key];
    var sel      = wwFbtSelected[key] || {};
    if (!variants) return;

    if (options && options.length > 0) {
      var allSelected = options.every(function(opt) { return !!sel[opt.name]; });
      if (!allSelected) { wwFbtHighlightUnpicked(key); return; }
    }

    var matched = variants.find(function(v) {
      if (!options || options.length === 0) return v.available;
      return options.every(function(opt, idx) { return v.options[idx] === sel[opt.name]; });
    });

    if (!matched) { wwFbtHighlightUnpicked(key); return; }

    if (!matched.available) {
      btn.textContent = 'Out of Stock';
      btn.disabled = true;
      setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 2000);
      return;
    }

    var variantId = matched.id;
    var original = btn.textContent;
    btn.textContent = 'Adding\u2026';
    btn.disabled = true;

    var muAdd = window.monster_addToCart || window.monster_atc;
    if (typeof muAdd === 'function') {
      muAdd({ id: variantId, quantity: 1 })
        .then(function() {
          wwAddedItems.add(variantId);
          var picker = document.getElementById('ww-fbt-picker-' + key);
          if (picker) picker.style.display = 'none';
          var addBtn = document.querySelector('#ww-fbt-' + key + ' .ww-fbt-add');
          if (addBtn) {
            addBtn.style.display = '';
            addBtn.textContent = '\u2713 Added';
            addBtn.style.color = '#1E7D4A';
            addBtn.style.borderColor = '#1E7D4A';
            addBtn.style.backgroundColor = '#E4F2EB';
            addBtn.disabled = true;
          }
          wwUpdateCartBadge();
        })
        .catch(function(err) {
          console.error('WW FBT add error:', err);
          btn.textContent = original;
          btn.disabled = false;
        });
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function(r) { return r.ok ? r.json() : r.json().then(function(e) { throw new Error(e.description); }); })
        .then(function() {
          wwAddedItems.add(variantId);
          var picker = document.getElementById('ww-fbt-picker-' + key);
          if (picker) picker.style.display = 'none';
          var addBtn = document.querySelector('#ww-fbt-' + key + ' .ww-fbt-add');
          if (addBtn) {
            addBtn.style.display = '';
            addBtn.textContent = '\u2713 Added';
            addBtn.style.color = '#1E7D4A';
            addBtn.style.borderColor = '#1E7D4A';
            addBtn.style.backgroundColor = '#E4F2EB';
            addBtn.disabled = true;
          }
          wwUpdateCartBadge();
          if (window.openCart) window.openCart();
        })
        .catch(function(err) {
          console.error('WW FBT add error:', err);
          btn.textContent = original;
          btn.disabled = false;
        });
    }
  };

  /* ─────────────────────────────────────────
     HIGHLIGHT UNPICKED OPTIONS
  ───────────────────────────────────────── */
  function wwFbtHighlightUnpicked(key) {
    var options = window.wwFbtOptions && window.wwFbtOptions[key];
    var sel = wwFbtSelected[key] || {};
    if (!options) return;
    options.forEach(function(opt) {
      if (!sel[opt.name]) {
        var lbl = document.getElementById('ww-fbt-lbl-' + key + '-' + opt.name);
        if (lbl) {
          lbl.style.color = '#C93232';
          lbl.firstChild.textContent = opt.name.toUpperCase() + ' \u2014 please choose one';
          setTimeout(function() {
            lbl.style.color = '';
            lbl.firstChild.textContent = opt.name.toUpperCase();
          }, 2500);
        }
      }
    });
  }

  window.wwFbtCollapse = function (key) {
    var picker  = document.getElementById('ww-fbt-picker-' + key);
    var addBtn  = document.querySelector('#ww-fbt-' + key + ' .ww-fbt-add');
    var confirm = document.querySelector('#ww-fbt-picker-' + key + ' .ww-fbt-confirm');
    if (picker)  picker.style.display = 'none';
    if (addBtn)  { addBtn.style.display = ''; addBtn.textContent = '+ Add'; addBtn.disabled = false; }
    if (confirm) { confirm.textContent = 'Add to Cart'; confirm.disabled = false; }
    wwFbtSelected[key] = {};
    document.querySelectorAll('[data-key="' + key + '"]').forEach(function(b) { b.classList.remove('sel'); });
  };

  window.wwFbtExpandAll = function () {
    ['coupler', 'ball', 'treats'].forEach(function(key) {
      var addBtn = document.querySelector('#ww-fbt-' + key + ' .ww-fbt-add');
      if (addBtn && !addBtn.disabled) wwFbtExpand(key, addBtn);
    });
    var first = document.getElementById('ww-fbt-coupler');
    if (first) first.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  window.wwAddBundle = function () { wwFbtExpandAll(); };

  /* ─────────────────────────────────────────
     COLOR HEX MAP
  ───────────────────────────────────────── */
  function wwColorHex(val) {
    var map = {
      'Yellow':'#F6EC44','Green':'#3BB44A','Orange':'#F57822',
      'Blue':'#00AAEC','Blueberry':'#00AAEC','Pink':'#F0287A',
      'Purple':'#6B2D9C','Black':'#2C2C2C','Silver':'#ABABAB',
      'Red':'#EC1C24','Natural':'#D4A96A','White':'#F0EDE8'
    };
    return map[val] || '#999';
  }

  /* ─────────────────────────────────────────
     COLLAPSIBLES
  ───────────────────────────────────────── */
  window.wwToggleCollapse = function (hdr) {
    var body  = hdr.nextElementSibling;
    var arrow = hdr.querySelector('.ww-c-arrow');
    var open  = body && body.style.display !== 'none';
    if (body)  body.style.display  = open ? 'none' : 'block';
    if (arrow) arrow.textContent   = open ? '+' : '\u2212';
    hdr.setAttribute('aria-expanded', String(!open));
  };

  /* ─────────────────────────────────────────
     FAQ
  ───────────────────────────────────────── */
  window.wwToggleFaq = function (btn) {
    var a     = btn.nextElementSibling;
    var arrow = btn.querySelector('.ww-faq-arrow');
    var open  = a && a.style.display !== 'none';
    if (a)     a.style.display   = open ? 'none' : 'block';
    if (arrow) arrow.textContent = open ? '+' : '\u2212';
  };

  /* ─────────────────────────────────────────
     MODALS — size guide + video
  ───────────────────────────────────────── */
  window.wwOpenSizeGuide  = function () { var m = document.getElementById('ww-size-modal'); if (m) { m.style.display = 'flex'; document.body.style.overflow = 'hidden'; } };
  window.wwCloseSizeGuide = function () { var m = document.getElementById('ww-size-modal'); if (m) { m.style.display = 'none'; document.body.style.overflow = ''; } };

  /* Collapsible size finder (v2 2026-04-27) — mirrors the WUNDERball
     PDP pattern. Closed-by-default to pull CTA up the fold. The
     section_id arg scopes the toggle to a specific size finder
     instance so multiple finders on a page (theoretical, not current)
     wouldn't cross-toggle. */
  window.wwToggleSizeFinder = function (sectionId) {
    var sf   = document.getElementById('ww-sf-' + sectionId);
    var btn  = document.getElementById('ww-sf-toggle-btn-' + sectionId);
    var body = document.getElementById('ww-sf-body-' + sectionId);
    if (!sf || !btn || !body) return;
    var isOpen = !sf.classList.contains('ww-sf--collapsed');
    if (isOpen) {
      sf.classList.add('ww-sf--collapsed');
      body.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      sf.classList.remove('ww-sf--collapsed');
      body.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
    }
  };
  window.wwOpenVideo = function (url) {
    if (!url) return;
    var e = '';
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([A-Za-z0-9_-]{11})/);
    if (yt) e = 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&modestbranding=1';
    if (!e) { var vm = url.match(/vimeo\.com\/(\d+)/); if (vm) e = 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1'; }
    if (!e) e = url;
    var iframe = document.getElementById('ww-video-iframe');
    var modal  = document.getElementById('ww-video-modal');
    if (!iframe || !modal) return;
    iframe.src = e; modal.style.display = 'flex'; document.body.style.overflow = 'hidden';
  };
  window.wwCloseVideo = function () {
    var iframe = document.getElementById('ww-video-iframe');
    var modal  = document.getElementById('ww-video-modal');
    if (iframe) iframe.src = '';
    if (modal)  modal.style.display = 'none';
    document.body.style.overflow = '';
  };

  /* ─────────────────────────────────────────
     COUNTDOWN TIMER
  ───────────────────────────────────────── */
  function startTimer() {
    var key = 'ww-timer-end';
    var stored = sessionStorage.getItem(key);
    var end = stored ? parseInt(stored, 10) : Date.now() + ((3 * 3600) + (47 * 60) + 22) * 1000;
    if (!stored) sessionStorage.setItem(key, end);
    function tick() {
      var r = Math.max(0, end - Date.now());
      var th = document.getElementById('ww-th'), tm = document.getElementById('ww-tm'), ts = document.getElementById('ww-ts');
      if (th) th.textContent = String(Math.floor(r / 3600000)).padStart(2, '0');
      if (tm) tm.textContent = String(Math.floor((r % 3600000) / 60000)).padStart(2, '0');
      if (ts) ts.textContent = String(Math.floor((r % 60000) / 1000)).padStart(2, '0');
      if (r > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  /* ─────────────────────────────────────────
     VIEWER COUNT
  ───────────────────────────────────────── */
  function flickerViewers() {
    var el = document.getElementById('ww-viewers');
    if (!el) return;
    var base = Math.floor(Math.random() * 9) + 10;
    el.textContent = base;
    setInterval(function() {
      base = Math.max(8, Math.min(22, base + (Math.floor(Math.random() * 3) - 1)));
      el.textContent = base;
    }, 12000);
  }

  /* ─────────────────────────────────────────
     INIT
  ───────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    startTimer();
    flickerViewers();

    document.querySelectorAll('.ww-pdp-wrap').forEach(function(wrap) {
      var sectionId = wrap.dataset.sectionId;
      if (!sectionId) return;
      if (!selectedOptions[sectionId]) selectedOptions[sectionId] = {};

      wrap.querySelectorAll('.ww-size-btn.sel').forEach(function(btn) {
        if (btn.dataset.option) selectedOptions[sectionId][btn.dataset.option] = btn.dataset.value;
      });

      wrap.querySelectorAll('.ww-color-row').forEach(function(row) {
        row.querySelectorAll('button.ww-c-dot').forEach(function(btn) {
          if (btn.dataset.selected === 'true') {
            btn.style.boxShadow = RING_ON; btn.style.transform = 'scale(1.12)';
            if (btn.dataset.option) selectedOptions[sectionId][btn.dataset.option] = btn.dataset.value;
          } else {
            btn.style.boxShadow = RING_OFF; btn.style.transform = 'scale(1)';
          }
        });
      });

      var variants = window.wwVariantData && window.wwVariantData[sectionId];
      var row = document.getElementById('ww-color-row-' + sectionId);
      var selSizeBtn = wrap.querySelector('.ww-size-btn.sel');
      if (row && variants) {
        wwFilterColors(row, variants, selSizeBtn ? selSizeBtn.dataset.value : null);
      }
    });

    document.querySelectorAll('.ww-faq-a').forEach(function(a) { a.style.display = 'none'; });
    document.querySelectorAll('.ww-collapse-body').forEach(function(b) { b.style.display = 'none'; b.removeAttribute('hidden'); });

    ['ww-size-modal','ww-video-modal'].forEach(function(id) {
      var m = document.getElementById(id);
      if (m) m.addEventListener('click', function(e) { if (e.target === m) { wwCloseSizeGuide(); wwCloseVideo(); } });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { wwCloseSizeGuide(); wwCloseVideo(); wwCloseMiniCart(); wwCloseProjectModal(); }
    });
  });

  /* ═══════════════════════════════════════════════
     WW MINI CART
  ═══════════════════════════════════════════════ */
  function wwBuildMiniCart() {
    if (document.getElementById('ww-mini-cart')) return;
    var backdrop = document.createElement('div');
    backdrop.className = 'ww-mc-backdrop';
    backdrop.id = 'ww-mc-backdrop';
    backdrop.addEventListener('click', wwCloseMiniCart);
    document.body.appendChild(backdrop);

    var panel = document.createElement('div');
    panel.id = 'ww-mini-cart';
    panel.innerHTML = [
      '<div class="ww-mc-inner">',
        '<div class="ww-mc-header">',
          '<div>',
            '<span class="ww-mc-title">Your Cart</span>',
            '<span class="ww-mc-count" id="ww-mc-count"></span>',
          '</div>',
          '<button class="ww-mc-close" onclick="wwCloseMiniCart()" type="button" aria-label="Close cart">&#215;</button>',
        '</div>',
        '<div class="ww-mc-items" id="ww-mc-items"><div class="ww-mc-loading">Loading your cart\u2026</div></div>',
        '<div class="ww-mc-footer" id="ww-mc-footer" style="display:none;">',
          '<div class="ww-mc-subtotal">',
            '<span class="ww-mc-subtotal-label">Subtotal</span>',
            '<span class="ww-mc-subtotal-price" id="ww-mc-subtotal"></span>',
          '</div>',
          '<div class="ww-mc-actions">',
            '<button type="button" class="ww-mc-cart-btn" onclick="wwCloseMiniCart()">Keep Shopping</button>',
            '<a href="/checkout" class="ww-mc-checkout-btn">Checkout</a>',
          '</div>',
          '<p class="ww-mc-note">Taxes and shipping calculated at checkout</p>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(panel);
  }

  window.wwOpenMiniCart = function () {
    wwBuildMiniCart();
    wwLoadMiniCart();
    document.getElementById('ww-mini-cart').classList.add('ww-mc-open');
    document.getElementById('ww-mc-backdrop').classList.add('ww-mc-open');
    document.body.style.overflow = 'hidden';
  };

  window.wwCloseMiniCart = function () {
    var panel    = document.getElementById('ww-mini-cart');
    var backdrop = document.getElementById('ww-mc-backdrop');
    if (panel)    panel.classList.remove('ww-mc-open');
    if (backdrop) backdrop.classList.remove('ww-mc-open');
    document.body.style.overflow = '';
  };

  function wwLoadMiniCart() {
    var itemsEl    = document.getElementById('ww-mc-items');
    var footerEl   = document.getElementById('ww-mc-footer');
    var subtotalEl = document.getElementById('ww-mc-subtotal');
    var countEl    = document.getElementById('ww-mc-count');
    if (!itemsEl) return;
    itemsEl.innerHTML = '<div class="ww-mc-loading">Loading your cart\u2026</div>';
    if (footerEl) footerEl.style.display = 'none';

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count || 0;
        if (countEl) countEl.textContent = count > 0 ? '(' + count + ' item' + (count === 1 ? '' : 's') + ')' : '';
        if (count === 0) {
          itemsEl.innerHTML = '<div class="ww-mc-loading" style="padding:40px 20px;">Your cart is empty</div>';
          return;
        }
        var html = '';
        (cart.items || []).forEach(function(item) {
          var variantInfo = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          html += '<div class="ww-mc-item">';
          html += '<div class="ww-mc-img">';
          if (item.image) html += '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy">';
          html += '</div><div class="ww-mc-item-info">';
          html += '<div class="ww-mc-item-title">' + (item.product_title || item.title) + '</div>';
          if (variantInfo) html += '<div class="ww-mc-item-variant">' + variantInfo + '</div>';
          if (item.quantity > 1) html += '<div class="ww-mc-item-variant">Qty: ' + item.quantity + '</div>';
          html += '</div><div class="ww-mc-item-price">' + wwMoney(item.final_line_price) + '</div></div>';
        });
        itemsEl.innerHTML = html;
        if (footerEl) footerEl.style.display = '';
        if (subtotalEl) subtotalEl.textContent = wwMoney(cart.total_price);
        wwUpdateCartBadge();
      })
      .catch(function() {
        itemsEl.innerHTML = '<div class="ww-mc-loading">Could not load cart. <a href="/cart">View cart page \u2192</a></div>';
      });
  }

  /* ─────────────────────────────────────────
     DONATE A WUNDERBALL — shelter box button
     Fetches product by handle for variant ID,
     then calls monster_addToCart (no variants).
  ───────────────────────────────────────── */
  window.wwDonateAdd = function(btn) {
    if (btn.disabled) return;
    var handle = btn.dataset.donateHandle || 'donate-a-wunderball';
    var original = btn.textContent;
    btn.textContent = 'Adding\u2026';
    btn.disabled = true;

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : Promise.reject('Product not found'); })
      .then(function(product) {
        var variantId = product.variants[0].id;
        var muAdd = window.monster_addToCart || window.monster_atc;
        if (typeof muAdd === 'function') {
          return muAdd({ id: variantId, quantity: 1 });
        } else {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          }).then(function() {
            wwUpdateCartBadge();
            if (window.openCart) window.openCart();
          });
        }
      })
      .then(function() {
        btn.textContent = '\u2713 Added to cart!';
        btn.classList.add('ww-added');
        wwUpdateCartBadge();
        setTimeout(function() {
          btn.textContent = original;
          btn.classList.remove('ww-added');
          btn.disabled = false;
        }, 3000);
      })
      .catch(function(err) {
        console.error('WW Donate add error:', err);
        btn.textContent = original;
        btn.disabled = false;
      });
  };

  /* ─────────────────────────────────────────
     PROJECT PLAY IT FORWARD MODAL
     WHY NOT IFRAME: Shopify sets X-Frame-Options:
     SAMEORIGIN — iframes are blocked site-wide.
     WHY NOT LIQUID INLINE: articles[] object is
     only available on blog templates, not product.
     SOLUTION: Same-origin fetch() of the blog post
     URL — fetch() bypasses X-Frame-Options entirely.
     We parse the HTML response, extract the article
     body, and inject just that into the modal panel.
     Content is cached after first load.
  ───────────────────────────────────────── */
  var wwProjectContent = null; /* cache after first fetch */

  var WW_PROJECT_URL = '/blogs/news/the-power-of-play-how-one-wunderball-can-help-shelter-dogs-get-adopted-70-faster';

  /* Selectors to try in order when extracting article body */
  var WW_ARTICLE_SELECTORS = [
    '.article__content',
    '.article-template__content',
    'article .rte',
    '.blog-article__content',
    'main article',
    'article',
    '.shopify-section article',
    'main'
  ];

  function wwBuildProjectModal() {
    if (document.getElementById('ww-project-modal')) return;

    var modal = document.createElement('div');
    modal.id = 'ww-project-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Project Play It Forward');
    modal.innerHTML = [
      '<div class="ww-pm-backdrop" onclick="wwCloseProjectModal()"></div>',
      '<div class="ww-pm-panel">',
        '<div class="ww-pm-header">',
          '<span class="ww-pm-title">Project Play It Forward</span>',
          '<button type="button" class="ww-pm-close" onclick="wwCloseProjectModal()" aria-label="Close">&#215;</button>',
        '</div>',
        '<div class="ww-pm-loading" id="ww-pm-loading">',
          '<div class="ww-pm-spinner"></div>',
          '<span>Loading…</span>',
        '</div>',
        '<div class="ww-pm-body" id="ww-pm-body" style="display:none;"></div>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);
  }

  function wwFetchProjectContent() {
    var loadingEl = document.getElementById('ww-pm-loading');
    var bodyEl    = document.getElementById('ww-pm-body');
    if (!bodyEl) return;

    /* Already fetched — just show it */
    if (wwProjectContent) {
      if (loadingEl) loadingEl.style.display = 'none';
      bodyEl.style.display = '';
      return;
    }

    fetch(WW_PROJECT_URL)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function(html) {
        /* Parse the full page HTML */
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        /* Try each selector until we find content */
        var extracted = null;
        for (var i = 0; i < WW_ARTICLE_SELECTORS.length; i++) {
          var el = doc.querySelector(WW_ARTICLE_SELECTORS[i]);
          if (el && el.textContent.trim().length > 100) {
            extracted = el;
            break;
          }
        }

        if (!extracted) {
          /* Fallback: grab everything in <main> */
          extracted = doc.querySelector('main') || doc.body;
        }

        /* Strip nav, header, footer, scripts from extracted node */
        ['header','footer','nav','script','style',
         '.site-header','.site-footer','.announcement-bar',
         '.cart-notification','.predictive-search'
        ].forEach(function(sel) {
          extracted.querySelectorAll(sel).forEach(function(el) { el.remove(); });
        });

        /* Cache and inject */
        wwProjectContent = extracted.innerHTML;
        bodyEl.innerHTML = '<div class="ww-project-page-content">' + wwProjectContent + '</div>';

        if (loadingEl) loadingEl.style.display = 'none';
        bodyEl.style.display = '';
      })
      .catch(function(err) {
        console.error('WW Project modal fetch error:', err);
        if (loadingEl) loadingEl.innerHTML = [
          '<div style="padding:24px;text-align:center;">',
            '<p style="margin-bottom:12px;">Could not load content.</p>',
            '<a href="' + WW_PROJECT_URL + '" target="_blank"',
              ' style="color:#1A1A18;font-weight:700;">',
              'Open in new tab →</a>',
          '</div>'
        ].join('');
      });
  }

  window.wwOpenProjectModal = function() {
    wwBuildProjectModal();
    var modal = document.getElementById('ww-project-modal');
    modal.classList.add('ww-pm-open');
    document.body.style.overflow = 'hidden';

    /* Fetch content (no-op after first load) */
    wwFetchProjectContent();

    modal._escHandler = function(e) {
      if (e.key === 'Escape') wwCloseProjectModal();
    };
    document.addEventListener('keydown', modal._escHandler);
  };

  window.wwCloseProjectModal = function() {
    var modal = document.getElementById('ww-project-modal');
    if (!modal) return;
    modal.classList.remove('ww-pm-open');
    document.body.style.overflow = '';
    if (modal._escHandler) {
      document.removeEventListener('keydown', modal._escHandler);
    }
  };

})();

/* ============================================================
   WACKYstore PDP Polish Pass \u2014 JS Additions  (v5)
   Append this to the BOTTOM of ww-pdp.js
   Session: 2026-04-14

   SAFE PATTERN: No emoji in string literals. Unicode escapes only.

   v5 CHANGES (from v4):
   - WUNDERtreats product detection + feature/FAQ patches
   - Hide comparison table + FBT on treats page
   - All v4 features preserved

   v4 CHANGES:
   - Product-aware features grid patching (WUNDERleash vs Urban Walk'r)
   - Product-aware FAQ patching + 3 new WUNDERleash FAQs
   - FBT heading renamed to "Complete Your Setup"
   - FBT +Add buttons filled black
   - Guarantee copy rewritten (compact, honest)
   ============================================================ */

(function wwPolishInit() {
  'use strict';

  /* ----------------------------------------------------------
     1. SCROLL-TRIGGERED REVEAL ANIMATIONS
     Step 1: JS adds .ww-anim-ready to grid containers
             (this triggers CSS to hide the cards)
     Step 2: IntersectionObserver adds .ww-revealed to each
             card as it enters the viewport (CSS animates them in)
     If Step 1 never runs, cards stay at full opacity.
     ---------------------------------------------------------- */
  function wwInitScrollReveal() {
    // Bail if browser doesn\u2019t support IntersectionObserver
    if (!('IntersectionObserver' in window)) return;  // cards stay visible

    // Respect reduced-motion preference
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // STEP 1: Opt-in the grid containers for animation
    var hiwGrid = document.querySelector('.ww-hiw-grid');
    var featGrid = document.querySelector('.ww-feat-grid');

    if (hiwGrid) hiwGrid.classList.add('ww-anim-ready');
    if (featGrid) featGrid.classList.add('ww-anim-ready');

    // Also opt-in section titles
    document.querySelectorAll('.ww-hiw-section .ww-section-title, .ww-feat-section .ww-section-title').forEach(function(title) {
      title.classList.add('ww-anim-ready-title');
    });

    // STEP 2: Observe cards and reveal them on scroll
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ww-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    // Observe How It Works cards
    document.querySelectorAll('.ww-hiw-card').forEach(function(card) {
      observer.observe(card);
    });

    // Observe Features Grid cards
    document.querySelectorAll('.ww-feat-card').forEach(function(card) {
      observer.observe(card);
    });

    // Observe section titles
    document.querySelectorAll('.ww-anim-ready-title').forEach(function(title) {
      observer.observe(title);
    });
  }


  /* ----------------------------------------------------------
     2. FBT \u2014 UPGRADE HEADING, BUTTONS & SHIPPING NUDGE
     ---------------------------------------------------------- */
  function wwPatchFbtFooter() {
    var fbtSection = document.querySelector('.ww-fbt-section');
    if (!fbtSection) return;

    // 2a. Rename heading from "Frequently bought together"
    //     to action-oriented conversion copy
    var fbtLabel = fbtSection.querySelector('.ww-fbt-label');
    if (fbtLabel && fbtLabel.textContent.toLowerCase().indexOf('frequently') !== -1) {
      fbtLabel.textContent = 'Complete Your Setup';
    }

    // 2b. Force +Add buttons to signature amber via inline styles.
    //     CSS also targets these, but the base rule uses
    //     background: none transparent !important which can
    //     win the cascade in some load-order scenarios.
    //     Inline !important is the nuclear guarantee.
    //     Amber #FFAE44 + charcoal text = matches main ATC + every
    //     other brand button across the redesign.
    var addBtns = fbtSection.querySelectorAll('.ww-fbt-add');
    var btnStyle = 'background:#FFAE44 !important;color:#1a1a18 !important;border:2px solid #FFAE44 !important;border-radius:6px !important;font-weight:700 !important;font-size:13px !important;padding:8px 18px !important;cursor:pointer;';
    addBtns.forEach(function(btn) {
      btn.setAttribute('style', btnStyle);
      // Also add hover handlers
      btn.addEventListener('mouseenter', function() {
        this.style.background = '#E89A2E';
        this.style.borderColor = '#E89A2E';
      });
      btn.addEventListener('mouseleave', function() {
        this.style.background = '#FFAE44';
        this.style.borderColor = '#FFAE44';
      });
    });

    // 2c. Free-shipping nudge retired (v3 Phase 1b).
    //     The "Add all three for $56.97" green panel cluttered the
    //     Complete Your Setup box and competed with the main ATC.
    //     Panel is now a clean 3-item cross-sell with amber +Add
    //     buttons per row; size/color is picked on each product's
    //     own PDP after the user clicks through.
  }


  /* ----------------------------------------------------------
     3. GUARANTEE \u2014 REWRITE COPY (compact + honest)
     Removes the "never had to honor this" claim.
     Keeps the brand voice, tightens to one line.
     ---------------------------------------------------------- */
  function wwPatchGuarantee() {
    if (wwIsTreats()) return; /* Treats has its own guarantee copy set in JSON */
    var guar = document.querySelector('.ww-guarantee');
    if (!guar) return;

    var h3 = guar.querySelector('.ww-guar-text h3');
    var p = guar.querySelector('.ww-guar-text p');

    if (h3) h3.textContent = '30-Day Tail-Waggin\u2019 Guarantee';
    if (p) p.textContent = 'Not working for your pup? Full refund \u2014 no questions, no restocking fee.';
  }


  /* ----------------------------------------------------------
     4. RELOCATE SHOP PAY INTO CTA AREA
     {{ form | payment_button }} renders inside the Liquid <form>
     at the bottom of the page. Moving just the payment button
     OUT of the form breaks Shopify\u2019s checkout connection.
     Fix: move the ENTIRE form into .ww-shop-pay-wrap. The ATC
     button links to the form by ID (form="ww-product-form-...")
     so it still works even when the form moves in the DOM.
     ---------------------------------------------------------- */
  function wwRelocateShopPay() {
    var shopPayWrap = document.querySelector('.ww-shop-pay-wrap');
    if (!shopPayWrap) return;

    // Already relocated?
    if (shopPayWrap.querySelector('.shopify-payment-button')) return;

    function doRelocate() {
      // Find the Liquid product form (contains the payment button)
      var form = document.querySelector('form[id*="ww-product-form"]');
      if (!form || !form.querySelector('.shopify-payment-button')) return false;

      // Move the entire form into the shop-pay-wrap
      shopPayWrap.appendChild(form);
      shopPayWrap.style.display = 'block';

      // Hide the form\u2019s hidden inputs visually (they\u2019re already hidden
      // but the form itself may take up space)
      form.style.margin = '0';
      form.style.padding = '0';

      return true;
    }

    // Try immediately
    if (doRelocate()) return;

    // Shopify loads the payment button async \u2014 poll for up to 5s
    var attempts = 0;
    var poller = setInterval(function() {
      attempts++;
      if (doRelocate() || attempts > 25) {
        clearInterval(poller);
      }
    }, 200);
  }


  /* ----------------------------------------------------------
     5. PRODUCT-AWARE FEATURES GRID PATCH
     The ww-features-grid.liquid section is hardcoded.
     We detect the product from the URL and swap copy for
     WUNDERleash (4\u20137 ft stretch vs Urban Walk\u2019r 3\u20134.5 ft).
     ---------------------------------------------------------- */
  /* Product detection helpers */
  function wwIsWunderleash() {
    return window.location.pathname.indexOf('wunderleash') !== -1;
  }
  function wwIsCoupler() {
    return window.location.pathname.indexOf('crazycouplr') !== -1 ||
           window.location.pathname.indexOf('coupl') !== -1;
  }
  function wwIsTreats() {
    return window.location.pathname.indexOf('wundertreats') !== -1;
  }

  function wwPatchFeatures() {
    var cards = document.querySelectorAll('.ww-feat-card');
    if (!cards.length) return;

    if (wwIsTreats()) {
      var treatFeats = [
        { title: 'All-natural ingredients', body: 'Oat flour, real peanut butter, farm-fresh eggs, sweet potato, honey, olive oil, flaxseed, blueberries. That\u2019s the full list. No fillers, no preservatives, no artificial colors or flavors. You can read every ingredient and actually know what it is.' },
        { title: 'Oven-baked in small batches', body: 'We bake at low temperatures to lock in flavor and nutrition. No high-heat extrusion that strips out the good stuff. Every batch comes out golden, crunchy, and packed with the smell that makes your dog lose their mind.' },
        { title: 'Only ~15 calories per treat', body: 'Low enough for guilt-free daily rewards and training sessions. Vets recommend limiting treats to 10% of daily calories \u2014 WUNDERtreats make it easy to stay in the sweet spot without your dog feeling short-changed.' },
        { title: 'Perfect training size', body: 'Small enough to give multiple rewards per session without overfeeding. Big enough that your dog knows they got something. The crunch is instant \u2014 no waiting for them to chew through a big biscuit while the moment passes.' },
        { title: 'Two irresistible flavors', body: 'Peanut Butter & Blueberry or Sweet Potato & Honey. Both packed with superfoods your dog actually wants to eat. Most dogs have a favorite \u2014 smart owners stock both and rotate.' },
        { title: 'Dogs know them by name', body: 'The second you reach for that bag, your dog knows exactly what\u2019s coming. The smell, the crunch, the taste \u2014 WUNDERtreats create a Pavlovian response that makes training, recall, and good behavior effortless.' }
      ];
      treatFeats.forEach(function(feat, i) {
        if (!cards[i]) return;
        var t = cards[i].querySelector('.ww-feat-title, h3, h4');
        var b = cards[i].querySelector('.ww-feat-body, p');
        if (t) t.textContent = feat.title;
        if (b) b.textContent = feat.body;
      });

    } else if (wwIsWunderleash()) {
      // Card 0: Length spec
      var t0 = cards[0] ? cards[0].querySelector('.ww-feat-title, h3, h4') : null;
      var b0 = cards[0] ? cards[0].querySelector('.ww-feat-body, p') : null;
      if (t0) t0.textContent = '4 ft. \u2014 stretches to 7 ft.';
      if (b0) b0.textContent = 'Long enough for a relaxed walk, stretchy enough to absorb every lunge. Your dog gets room to explore while still learning not to pull.';

      // Card 4: Color count (8 colors for WUNDERleash, not 9)
      var t4 = cards[4] ? cards[4].querySelector('.ww-feat-title, h3, h4') : null;
      var b4 = cards[4] ? cards[4].querySelector('.ww-feat-body, p') : null;
      if (t4) t4.textContent = '8 colors, 3 sizes';
      if (b4) b4.textContent = '24 combinations for every dog from 5 lbs to 150 lbs. Pick the color that matches your dog\u2019s energy.';

    } else if (wwIsCoupler()) {
      // Full rewrite \u2014 all 6 feature cards for the CRAZYcoupl\u2019r
      var cFeats = [
        { title: '100% tangle-free', body: 'Independent rubber arms let each dog move freely. Left, right, sniff, stop \u2014 no crossed leashes, no knots, no wrestling match.' },
        { title: 'Works with any leash', body: 'Clip your favorite leash to the center O-ring. Best with WACKYwalk\u2019r no-pull leashes, but compatible with any standard leash.' },
        { title: 'Heavy-duty swivel clips', body: '360\u00B0 swivel clips on each end prevent twisting at the collar. Dogs spin, turn, circle \u2014 the coupler stays untangled.' },
        { title: 'Natural rubber latex', body: 'Same durable, chew-resistant rubber as our leashes. UV-resistant, weatherproof, and built to outlast nylon couplers.' },
        { title: '6 colors, 3 sizes', body: '18 combinations. Match your leash, match your dogs, or go wild. Every coupl\u2019r ships ready to walk.' },
        { title: 'Size to the bigger dog', body: 'Walking a 20 lb and a 60 lb dog? Get the Medium. The smaller dog stays comfortable \u2014 the bigger dog sets the strength requirement.' }
      ];

      cFeats.forEach(function(feat, i) {
        if (!cards[i]) return;
        var t = cards[i].querySelector('.ww-feat-title, h3, h4');
        var b = cards[i].querySelector('.ww-feat-body, p');
        if (t) t.textContent = feat.title;
        if (b) b.textContent = feat.body;
      });
    }
  }


  /* ----------------------------------------------------------
     5b. COMPARISON TABLE \u2014 REPLACE "UNDER $30" ROW
     The last row says "Under $30" which is inaccurate for most
     variants. Replace with "Absorbs pulling force" \u2014 a unique
     differentiator that\u2019s always true and never needs updating.
     Applies to ALL product pages (not just WUNDERleash).
     ---------------------------------------------------------- */
  var CK = '<span class="ww-td-check">\u2713</span>';
  var CX = '<span class="ww-td-cross">\u2715</span>';

  function wwPatchComparisonTable() {
    var rows = document.querySelectorAll('.ww-compare-table tr');
    if (!rows.length) return;

    /* ----- WUNDERtreats: rewrite full table ----- */
    if (wwIsTreats()) {
      /* Rewrite header row */
      var headerRow = rows[0];
      var ths = headerRow.querySelectorAll('th');
      if (ths.length >= 5) {
        ths[0].textContent = '';
        ths[1].innerHTML = '<strong>WUNDER</strong>treats';
        ths[2].textContent = 'Store-bought';
        ths[3].textContent = 'Raw diet';
        ths[4].textContent = 'Homemade';
      }

      var treatsRows = [
        ['All-natural ingredients',          CK, CX, CK, CK],
        ['No fillers or preservatives',      CK, CX, CK, CK],
        ['Consistent nutrition per treat',   CK, CX, CX, CX],
        ['Perfect size for training',        CK, CX, CX, CX],
        ['Shelf-stable (no refrigeration)',   CK, CK, CX, CX],
        ['Oven-baked for safety',            CK, CX, CX, CK],
        ['Under 15 calories per treat',      CK, CX, CK, CX],
        ['Dogs obsess over the taste',       CK, CX, CK, CK]
      ];

      for (var r = 0; r < treatsRows.length; r++) {
        var row = rows[r + 1];
        if (!row) {
          var lastRow = rows[rows.length - 1];
          row = lastRow.cloneNode(true);
          lastRow.parentNode.appendChild(row);
          rows = document.querySelectorAll('.ww-compare-table tr');
        }
        var cells = row.querySelectorAll('td');
        if (!cells.length) continue;
        cells[0].textContent = treatsRows[r][0];
        if (cells[1]) cells[1].innerHTML = treatsRows[r][1];
        if (cells[2]) cells[2].innerHTML = treatsRows[r][2];
        if (cells[3]) cells[3].innerHTML = treatsRows[r][3];
        if (cells[4]) cells[4].innerHTML = treatsRows[r][4];
      }

      var treatsBody = rows[0].parentNode;
      while (treatsBody.querySelectorAll('tr').length > treatsRows.length + 1) {
        treatsBody.removeChild(treatsBody.lastElementChild);
      }
      return;
    }

    /* ----- CRAZYcoupl\u2019r: rewrite full table ----- */
    if (wwIsCoupler()) {
      var couplerRows = [
        ['Tangle-free design',         CK, CX, CX, CX],
        ['Works with any leash',       CK, CX, CX, CX],
        ['Absorbs pulling force',      CK, CX, CX, CX],
        ['360\u00B0 swivel clips',     CK, CX, CX, CX],
        ['Weather & UV resistant',     CK, CX, CK, CK],
        ['No moving parts to jam',     CK, CK, CK, CX],
        ['Independent arm movement',   CK, CX, CX, CX]
      ];

      for (var r = 0; r < couplerRows.length; r++) {
        var row = rows[r + 1];
        if (!row) {
          var lastRow = rows[rows.length - 1];
          row = lastRow.cloneNode(true);
          lastRow.parentNode.appendChild(row);
          rows = document.querySelectorAll('.ww-compare-table tr');
        }
        var cells = row.querySelectorAll('td');
        if (!cells.length) continue;
        cells[0].textContent = couplerRows[r][0];
        if (cells[1]) cells[1].innerHTML = couplerRows[r][1];
        if (cells[2]) cells[2].innerHTML = couplerRows[r][2];
        if (cells[3]) cells[3].innerHTML = couplerRows[r][3];
        if (cells[4]) cells[4].innerHTML = couplerRows[r][4];
      }

      var tbody = rows[0].parentNode;
      while (tbody.querySelectorAll('tr').length > couplerRows.length + 1) {
        tbody.removeChild(tbody.lastElementChild);
      }
      return;
    }

    /* ----- Leash pages: replace "Under $30" row ----- */
    rows.forEach(function(row) {
      var cells = row.querySelectorAll('td');
      if (!cells.length) return;

      var featureCell = cells[0];
      if (featureCell && featureCell.textContent.trim().toLowerCase().indexOf('under $') !== -1) {
        featureCell.textContent = 'Absorbs pulling force';
        if (cells[1]) cells[1].innerHTML = CK;
        if (cells[2]) cells[2].innerHTML = CX;
        if (cells[3]) cells[3].innerHTML = CX;
        if (cells[4]) cells[4].innerHTML = CX;
      }
    });
  }


  /* ----------------------------------------------------------
     6. PRODUCT-AWARE FAQ PATCH
     Same issue \u2014 ww-faq.liquid is hardcoded with Urban Walk\u2019r
     copy. We swap Q/A text for WUNDERleash and add 3 new FAQs.
     ---------------------------------------------------------- */
  /* Helper: set FAQ question text.
     DOM structure is: .ww-faq-q > <span>Question</span> <span.ww-faq-arrow>+</span>
     The question text lives in the FIRST <span> that isn\u2019t .ww-faq-arrow.
     We also remove any stray bare text nodes to avoid doubling. */
  function wwSetFaqQuestion(faqItem, text) {
    var qWrap = faqItem.querySelector('.ww-faq-q');
    if (!qWrap) return;

    // Find the question <span> (first span without .ww-faq-arrow)
    var spans = qWrap.querySelectorAll('span');
    var qSpan = null;
    for (var i = 0; i < spans.length; i++) {
      if (!spans[i].classList.contains('ww-faq-arrow')) {
        qSpan = spans[i];
        break;
      }
    }

    if (qSpan) {
      qSpan.textContent = text;
    }

    // Clean up any bare text nodes (from prior bad patches or Liquid whitespace)
    var kids = qWrap.childNodes;
    for (var j = kids.length - 1; j >= 0; j--) {
      if (kids[j].nodeType === 3) {
        qWrap.removeChild(kids[j]);
      }
    }
  }

  function wwPatchFaq() {
    /* ----- WUNDERtreats FAQ ----- */
    if (wwIsTreats()) {
      wwPatchTreatsFaq();
      return;
    }

    /* ----- CRAZYcoupl\u2019r FAQ ----- */
    if (wwIsCoupler()) {
      wwPatchCouplerFaq();
      return;
    }

    if (!wwIsWunderleash()) return;

    var faqItems = document.querySelectorAll('.ww-faq-section .ww-faq-item');
    if (!faqItems.length) return;

    // Q2 (index 1): "Is 3 feet too short?" \u2192 update for 4 ft
    if (faqItems[1]) {
      wwSetFaqQuestion(faqItems[1], 'Is 4 feet too short for a normal walk?');
      var a1 = faqItems[1].querySelector('.ww-faq-a');
      if (a1) a1.textContent = 'Four feet at rest is the sweet spot \u2014 close enough for control, and the stretch to 7 ft. gives your dog plenty of room to sniff and explore without bolting. Most owners say it feels more natural than a standard 6-foot leash within the first walk.';
    }

    // Q5 (index 4): References "Urban Walk\u2019r" \u2192 update for WUNDERleash
    if (faqItems[4]) {
      wwSetFaqQuestion(faqItems[4], 'How does the CRAZYcoupl\u2019r work with this?');
      var a4 = faqItems[4].querySelector('.ww-faq-a');
      if (a4) a4.textContent = 'The WUNDERleash is the perfect length for 2-dog walking when you add the CRAZYcoupl\u2019r. Both dogs get the no-pull benefit \u2014 you hold one leash.';
    }

    // --- ADD 3 NEW FAQs ---
    var faqList = document.querySelector('.ww-faq-section .ww-faq-list, .ww-faq-section .ww-faq-items');
    if (!faqList) {
      // Try the section itself as container
      faqList = document.querySelector('.ww-faq-section');
    }
    if (!faqList) return;

    // Don\u2019t inject twice
    if (faqList.querySelector('[data-ww-injected-faq]')) return;

    var newFaqs = [
      {
        q: 'What\u2019s the difference between the WUNDERleash and the Urban Walk\u2019r?',
        a: 'Length. The Urban Walk\u2019r is a 3-foot leash that stretches to 4.5 ft. \u2014 built for tight city sidewalks and maximum control. The WUNDERleash starts at 4 feet and stretches to 7 ft., giving your dog more room to explore while still teaching them not to pull. Same no-pull physics, same natural rubber, just more range.'
      },
      {
        q: 'How long does the WUNDERleash last?',
        a: 'Most customers report 2\u20133+ years of daily use. The natural rubber is UV-resistant and weatherproof. Unlike nylon leashes that fray at stress points, the elastic core distributes force evenly so there\u2019s no single weak spot.'
      },
      {
        q: 'Can my dog chew through it?',
        a: 'Dogs naturally resist chewing natural rubber latex \u2014 the texture and taste discourage it. That said, no leash is indestructible if a determined chewer goes at it unsupervised. For heavy chewers, we recommend supervising until the habit fades (the no-pull effect usually reduces leash frustration quickly).'
      }
    ];

    // Clone the structure of an existing FAQ item
    var template = faqItems[0];
    if (!template) return;

    newFaqs.forEach(function(faq) {
      var clone = template.cloneNode(true);
      clone.setAttribute('data-ww-injected-faq', 'true');

      // Set question text in the <span> (same helper as above)
      wwSetFaqQuestion(clone, faq.q);

      // Set answer text
      var aEl = clone.querySelector('.ww-faq-a');
      if (aEl) aEl.textContent = faq.a;

      // Make sure it\u2019s collapsed
      if (clone.tagName === 'DETAILS') clone.removeAttribute('open');

      faqList.appendChild(clone);
    });
  }


  /* ----------------------------------------------------------
     6b. CRAZYcoupl\u2019r FAQ \u2014 FULL REWRITE
     The hardcoded Liquid FAQ is for leash pages. On the coupler
     PDP we replace ALL questions with coupler-specific ones.
     ---------------------------------------------------------- */
  function wwPatchCouplerFaq() {
    var faqItems = document.querySelectorAll('.ww-faq-section .ww-faq-item');
    if (!faqItems.length) return;

    var couplerFaqs = [
      {
        q: 'Will it work with my current leash?',
        a: 'Yes. The CRAZYcoupl\u2019r attaches to any standard leash via the center O-ring. Clip your leash on and you\u2019re good to go. It pairs best with the WUNDERleash or Urban Walk\u2019r for no-pull + no-tangle in one setup, but any leash works.'
      },
      {
        q: 'Can I use it with a retractable leash?',
        a: 'We don\u2019t recommend it. Retractable leashes create inconsistent tension that fights the coupler\u2019s natural flex, and the thin cord can easily get caught on or wrapped around your dogs\u2019 legs or paws, causing injury. They also get tangled around both dogs and humans much more easily when walking multiple dogs at once. A fixed-length leash gives both dogs steady, predictable movement and keeps you in full control.'
      },
      {
        q: 'My dogs are different sizes \u2014 what size do I get?',
        a: 'Size to the larger dog. The bigger dog sets the strength requirement. The smaller dog will be perfectly comfortable \u2014 the flexible rubber arms adjust to each dog\u2019s pull independently.'
      },
      {
        q: 'What\u2019s the difference between Small, Medium, and Large?',
        a: 'Small is for dogs 6\u201315 lbs each (toy breeds). Medium handles 16\u201360 lbs each (Poodles, Boxers, Bulldogs, Beagles, Doodles). Large is for 61\u2013100 lbs each (Great Danes, Rottweilers, Mastiffs, most Labs and Goldens). When in doubt, size up.'
      },
      {
        q: 'Does it stop pulling?',
        a: 'The CRAZYcoupl\u2019r is designed to prevent tangling while providing relief from the jarring nature of dogs pulling. The natural rubber arms flex and absorb shock instead of transferring every lunge straight to your wrist. It\u2019s not a no-pull trainer on its own, but pair it with a WUNDERleash or Urban Walk\u2019r and you get no-pull + no-tangle in one system \u2014 the elastic leash teaches loose-leash walking while the coupler keeps both dogs on separate, tangle-free arms.'
      },
      {
        q: 'How do I clean it?',
        a: 'Wipe it down with a damp cloth or rinse under the tap. The natural rubber is weatherproof, UV-resistant, and dries quickly. No special care needed \u2014 it\u2019s built for daily outdoor use.'
      }
    ];

    // Rewrite existing items, then add extras via cloning
    for (var i = 0; i < couplerFaqs.length; i++) {
      var item;
      if (i < faqItems.length) {
        item = faqItems[i];
      } else {
        // Clone the first item as template
        item = faqItems[0].cloneNode(true);
        item.setAttribute('data-ww-injected-faq', 'true');
        if (item.tagName === 'DETAILS') item.removeAttribute('open');
        var faqList = faqItems[0].parentNode;
        faqList.appendChild(item);
      }
      wwSetFaqQuestion(item, couplerFaqs[i].q);
      var aEl = item.querySelector('.ww-faq-a');
      if (aEl) aEl.textContent = couplerFaqs[i].a;
    }

    // Remove extra items if the original had more than we need
    var allItems = document.querySelectorAll('.ww-faq-section .ww-faq-item');
    for (var j = allItems.length - 1; j >= couplerFaqs.length; j--) {
      allItems[j].parentNode.removeChild(allItems[j]);
    }
  }


  /* ----------------------------------------------------------
     6c. WUNDERtreats FAQ \u2014 FULL REWRITE
     Treats page gets its own set of FAQ questions focused on
     ingredients, feeding, allergies, and storage.
     ---------------------------------------------------------- */
  function wwPatchTreatsFaq() {
    var faqItems = document.querySelectorAll('.ww-faq-section .ww-faq-item');
    if (!faqItems.length) return;

    var treatFaqs = [
      {
        q: 'What are the ingredients?',
        a: 'PB & Blueberry: Oat flour, eggs, flaxseed, peanut butter, honey, olive oil, blueberries, rosemary extract, blueberry oil. Sweet Potato & Honey: Oat flour, flaxseed, sweet potato, olive oil, honey, eggs, cinnamon, ginger, rosemary extract. That\u2019s it. No fillers, no corn, no soy, no wheat, no artificial anything.'
      },
      {
        q: 'Are they good for dogs with allergies?',
        a: 'WUNDERtreats are free from corn, soy, wheat, and artificial additives \u2014 common allergens that trigger sensitivities in many dogs. However, the PB & Blueberry flavor does contain peanut butter and eggs. If your dog has specific food allergies, check the ingredient list against their known triggers or consult your vet. The Sweet Potato & Honey flavor is a great option for dogs sensitive to peanuts.'
      },
      {
        q: 'How many treats can I give per day?',
        a: 'Vets recommend treats make up no more than 10% of your dog\u2019s daily caloric intake. At roughly 15 calories per treat, most dogs can enjoy several per day without any issues. Use them for training, walks, or as a reward for being a good dog. Always provide fresh water.'
      },
      {
        q: 'How should I store them?',
        a: 'Keep them in a cool, dry place with the bag sealed. No refrigeration needed. They\u2019re oven-baked with natural preservatives (rosemary extract), so they stay fresh for months. If you notice any change in smell, texture, or color, it\u2019s time for a new bag.'
      },
      {
        q: 'Can puppies have WUNDERtreats?',
        a: 'Yes! WUNDERtreats are safe for puppies old enough to eat solid food (typically 8+ weeks). The small size is perfect for training and socialization. Start with either flavor \u2014 puppies tend to go crazy for both. Just be mindful of total daily calorie intake for small puppies.'
      },
      {
        q: 'Why are these better than store-bought treats?',
        a: 'Read the ingredient list on most store-bought treats: corn, wheat gluten, meat by-products, artificial colors, BHA, BHT. WUNDERtreats use real food you can pronounce. They\u2019re baked in small batches, not mass-produced in a factory. The difference shows up in your dog\u2019s reaction \u2014 and their digestion.'
      },
      {
        q: 'Do they actually help with training?',
        a: 'Absolutely. The best training treat is one your dog will do anything for \u2014 and WUNDERtreats are that treat. The small size means you can give multiple rewards per session without overfeeding. The instant crunch means no downtime waiting for your dog to chew. Pair them with a WUNDERleash for no-pull training and you\u2019ve got the complete Walk. Train. Reward. system.'
      },
      {
        q: 'What\u2019s the shipping and return policy?',
        a: 'WUNDERtreats ship in 1 business day from our Hatfield, Pennsylvania HQ. Free shipping on orders $49+. Not satisfied? We offer a 30-Day Tail Waggin\u2019 Guarantee \u2014 if your dog doesn\u2019t come running for them, reach out and we\u2019ll make it right.'
      }
    ];

    /* Rewrite existing items, clone extras if needed */
    for (var i = 0; i < treatFaqs.length; i++) {
      var item;
      if (i < faqItems.length) {
        item = faqItems[i];
      } else {
        item = faqItems[0].cloneNode(true);
        item.setAttribute('data-ww-injected-faq', 'true');
        if (item.tagName === 'DETAILS') item.removeAttribute('open');
        var faqList = faqItems[0].parentNode;
        faqList.appendChild(item);
      }
      wwSetFaqQuestion(item, treatFaqs[i].q);
      var aEl = item.querySelector('.ww-faq-a');
      if (aEl) aEl.textContent = treatFaqs[i].a;
    }

    /* Remove extras beyond our count */
    var allItems = document.querySelectorAll('.ww-faq-section .ww-faq-item');
    for (var j = allItems.length - 1; j >= treatFaqs.length; j--) {
      allItems[j].parentNode.removeChild(allItems[j]);
    }
  }


  /* ----------------------------------------------------------
     6d. TREATS PAGE: COMPARISON + FBT CUSTOMIZATION
     Comparison table is now patched in wwPatchComparisonTable().
     FBT is shown with cross-sell narrative below.
     ---------------------------------------------------------- */

  function wwPatchTreatsFbt() {
    /* NEUTERED 2026-04-30 \u2014 all responsibilities moved into Liquid:
       - Heading is set via the section's `heading` setting in
         templates/product.wundertreats.json ("Complete Your Setup").
       - Treats item exclusion is handled by ww-bundle.liquid v11's
         is_treats_page branch (renders coupler + leash + ball, skips treats).
       - The mystery "Walk. Train. Reward. Play." narrative paragraph
         is removed entirely \u2014 was a campaign artifact that no longer
         fits the section's clean, parity-with-leash-page design.
       - Crosssell hiding is also a no-op now (treats template doesn't
         include a ww_crosssell section to begin with).
       Function kept as a no-op stub in case any other JS references it. */
    return;
  }


  /* ----------------------------------------------------------
     7. STRIKETHROUGH PRICING FOR AUTOMATIC DISCOUNTS
     Shopify automatic cart discounts don\u2019t show on the PDP.
     This detects discounted products by URL, calculates the
     sale price, and injects strikethrough + badge + updated ATC.
     The original .ww-sale-price stays in the DOM (hidden) so
     wwSelectSize() can still update it on variant changes.
     A MutationObserver syncs our display whenever that happens.

     CONFIG: Update WW_DISCOUNTS when the promotion changes.
     ---------------------------------------------------------- */
  /* WW_DISCOUNTS — DYNAMIC 2026-05-06.
     Reads from window.wwLeashSalePct, which is injected by the
     ww-sale-config.liquid snippet (value comes from Theme settings →
     WACKYstore Sales → "Leash sale percent"). Change the sale in the
     theme editor — no code changes needed.
     Rounding: Math.floor(originalCents * discount) matches Shopify cart. */
  var wwThemePct = window.wwLeashSalePct || 0;
  var WW_DISCOUNTS = {};
  if (wwThemePct > 0) {
    var d = wwThemePct / 100;
    WW_DISCOUNTS = {
      'wunderleash': d,
      'urban-walkr': d,
      'shorter-no-pull': d,
      'crazycouplr': d,
      'coupl': d
    };
  }

  function wwGetDiscount() {
    var path = window.location.pathname.toLowerCase();
    for (var key in WW_DISCOUNTS) {
      if (path.indexOf(key) !== -1) return WW_DISCOUNTS[key];
    }
    return 0;
  }

  function wwFormatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function wwParseMoney(str) {
    var num = parseFloat(str.replace(/[^0-9.]/g, ''));
    return Math.round(num * 100);
  }

  /* Match Shopify's rounding: floor the discount amount, then subtract.
     Shopify: $29.99 * 20% = $5.998 -> floors to $5.99 -> $29.99 - $5.99 = $24.00
     This prevents the 1-cent mismatch between PDP and cart. */
  function wwDiscountedPrice(originalCents, discount) {
    var savingsCents = Math.floor(originalCents * discount);
    return originalCents - savingsCents;
  }

  function wwApplyStrikethrough() {
    var discount = wwGetDiscount();
    if (!discount) return;

    var salePriceEl = document.querySelector('.ww-sale-price');
    if (!salePriceEl) return;

    var priceRow = salePriceEl.closest('.ww-price-row');
    if (!priceRow) return;

    var originalCents = wwParseMoney(salePriceEl.textContent);
    if (!originalCents || originalCents <= 0) return;

    var discountedCents = wwDiscountedPrice(originalCents, discount);
    var pctOff = Math.round(discount * 100);

    // Check if display elements already exist (variant change)
    var nowEl = priceRow.querySelector('.ww-now-price');
    var wasEl = priceRow.querySelector('.ww-was-price');
    var badgeEl = priceRow.querySelector('.ww-save-badge');

    if (nowEl && wasEl && badgeEl) {
      nowEl.textContent = wwFormatMoney(discountedCents);
      wasEl.textContent = wwFormatMoney(originalCents);
      badgeEl.textContent = pctOff + '% OFF';
      wwUpdateInstallment(discountedCents);
      return;
    }

    // --- First run: hide original, add display elements ---
    salePriceEl.style.position = 'absolute';
    salePriceEl.style.width = '1px';
    salePriceEl.style.height = '1px';
    salePriceEl.style.overflow = 'hidden';
    salePriceEl.style.clip = 'rect(0,0,0,0)';
    salePriceEl.setAttribute('aria-hidden', 'true');

    nowEl = document.createElement('span');
    nowEl.className = 'ww-now-price';
    nowEl.textContent = wwFormatMoney(discountedCents);

    wasEl = document.createElement('span');
    wasEl.className = 'ww-was-price';
    wasEl.textContent = wwFormatMoney(originalCents);

    badgeEl = document.createElement('span');
    badgeEl.className = 'ww-save-badge';
    badgeEl.textContent = pctOff + '% OFF';

    priceRow.insertBefore(nowEl, salePriceEl);
    priceRow.insertBefore(wasEl, salePriceEl);
    priceRow.insertBefore(badgeEl, salePriceEl);

    wwUpdateInstallment(discountedCents);

    // MutationObserver: when wwSelectSize() updates .ww-sale-price, resync
    var priceObs = new MutationObserver(function() {
      var newCents = wwParseMoney(salePriceEl.textContent);
      if (newCents && newCents > 0) {
        var nd = wwDiscountedPrice(newCents, discount);
        nowEl.textContent = wwFormatMoney(nd);
        wasEl.textContent = wwFormatMoney(newCents);
        wwUpdateInstallment(nd);
      }
    });
    priceObs.observe(salePriceEl, { characterData: true, childList: true, subtree: true });
  }

  function wwUpdateInstallment(discountedCents) {
    var noteB = document.querySelector('.ww-price-note b');
    if (noteB) {
      var installment = Math.ceil(discountedCents / 4);
      noteB.textContent = wwFormatMoney(installment);
    }
  }

  /* Patch the ATC button price to match the discounted amount.
     Button text is "Add to Cart \u2014 $XX.XX". Same MutationObserver
     pattern: wwSelectSize() updates it, we re-patch. */
  function wwPatchAtcPrice() {
    var discount = wwGetDiscount();
    if (!discount) return;

    var atcBtn = document.querySelector('.ww-cta-main');
    if (!atcBtn) return;

    function patchText() {
      var text = atcBtn.textContent.trim();
      var match = text.match(/^(Add to Cart\s*[\u2014\u2013\-]+\s*)\$([0-9.]+)$/);
      if (!match) return;
      var origCents = Math.round(parseFloat(match[2]) * 100);
      var discCents = wwDiscountedPrice(origCents, discount);
      atcBtn.textContent = match[1] + wwFormatMoney(discCents);
    }

    patchText();

    var atcObs = new MutationObserver(function() {
      atcObs.disconnect();
      patchText();
      atcObs.observe(atcBtn, { characterData: true, childList: true, subtree: true });
    });
    atcObs.observe(atcBtn, { characterData: true, childList: true, subtree: true });
  }


  /* ----------------------------------------------------------
     7a. SECTION RENDERING INJECTION
     Mobile bug that spawned this helper: after adding a donation
     ball via XHR, Monster Cart's drawer would open but render
     EMPTY, because its internal HTML was last painted when the
     cart was empty (shopper tapped the cart icon earlier, saw
     empty state, closed it — that empty HTML stayed in the DOM).
     Monster Cart's own XHR monkey-patch is supposed to re-render
     the drawer after /cart/add.js, but on mobile it races the
     drawer's open() call and loses, so the old empty DOM shows.
     Shoppers then add the item AGAIN thinking the first add
     failed — duplicate line items, confused customers, refunds.
     Fix: pass `sections` in the POST body to /cart/add.js, and
     when Shopify returns the freshly-rendered section HTML, swap
     it into the DOM ourselves. No race condition — by the time
     we open the drawer, its content is already up-to-date.
     ---------------------------------------------------------- */
  // Accepts either the full /cart/add.js response (with .sections) or
  // a bare sections object. Strategy:
  //   1. Call Dawn's <cart-drawer>.renderContents(parsedState) — this is
  //      the proper Shopify OS 2.0 API. Without it, our injected HTML
  //      gets overwritten the moment the drawer re-renders from its own
  //      internal state. Requires passing the full parsedState (not just
  //      sections) because renderContents expects parsedState.sections.
  //   2. Same for <cart-notification>.renderContents.
  //   3. Fall back to manual innerHTML swap per section ID — still needed
  //      for non-Dawn drawers like Monster Cart.
  function wwInjectCartSections(respOrSections) {
    if (!respOrSections) return;
    var parsedState = respOrSections.sections ? respOrSections : null;
    var sections    = respOrSections.sections || respOrSections;
    if (!sections || typeof sections !== 'object') return;

    // Strategy 1+2: Dawn's cart-drawer / cart-notification. Safe try/catch
    // so a throw inside Dawn's method doesn't break the fallback path.
    try {
      var dawnDrawer = document.querySelector('cart-drawer');
      if (dawnDrawer && typeof dawnDrawer.renderContents === 'function' && parsedState) {
        dawnDrawer.renderContents(parsedState);
      }
    } catch (e) {}
    try {
      var dawnNotif = document.querySelector('cart-notification');
      if (dawnNotif && typeof dawnNotif.renderContents === 'function' && parsedState) {
        dawnNotif.renderContents(parsedState);
      }
    } catch (e) {}

    // Strategy 3: manual swap per section ID. Shopify returns each section's
    // full <div id="shopify-section-..."> wrapper. Try common locators.
    Object.keys(sections).forEach(function(key) {
      var html = sections[key];
      if (!html) return;
      var selectors = [
        '#shopify-section-' + key,
        '[data-section-id="' + key + '"]',
        '[data-section="' + key + '"]'
      ];
      var target = null;
      for (var i = 0; i < selectors.length; i++) {
        target = document.querySelector(selectors[i]);
        if (target) break;
      }
      if (!target) return;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newSection = temp.querySelector('#shopify-section-' + key) || temp.firstElementChild;
      if (newSection) {
        target.innerHTML = newSection.innerHTML;
      }
    });
  }

  /* ----------------------------------------------------------
     7b. CART DRAWER REFRESH + MAIN ATC INTERCEPT
     Native form submit posts to /cart/add and redirects to /cart,
     which (a) navigates the shopper off the PDP and (b) doesn't
     fire any of the cart-drawer refresh events. Monster Cart's own
     intercept is flaky on desktop for this form (leash PDPs).
     Fix: AJAX the submit to /cart/add.js, then fan out every common
     cart-drawer refresh event + try every known opener, mirroring
     the pattern we ship on WUNDERball (see ww-wunderball.js).
     ---------------------------------------------------------- */
  function wwRefreshAndOpenCartDrawer() {
    // SEQUENTIAL refresh — fetch sections, INJECT them into the DOM, THEN
    // dispatch events and open the drawer. This ordering matters: if we
    // open the drawer before the DOM is updated, Monster Cart/Dawn renders
    // stale state (the bug that happens on second-add-after-delete —
    // drawer was already visible showing empty state, we dispatch events,
    // and by the time section HTML arrives the drawer has already painted
    // its empty state to the screen).
    //
    // Single fetch to /cart.js?sections=... returns BOTH the cart object
    // (for events) AND the rendered section HTML (for DOM injection).
    var sectionList = [
      'cart-drawer', 'monster-cart', 'monster-cart-drawer',
      'cart-notification', 'cart-icon-bubble', 'cart'
    ];
    var presentSections = sectionList.filter(function(k) {
      return document.querySelector(
        '#shopify-section-' + k + ', [data-section-id="' + k + '"], [data-section="' + k + '"]'
      );
    });

    var fetchUrl = presentSections.length
      ? '/cart.js?sections=' + encodeURIComponent(presentSections.join(','))
      : '/cart.js';

    return fetch(fetchUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .catch(function() { return null; })
      .then(function(cart) {
        // STEP 1 — inject refreshed section HTML into the DOM BEFORE
        // any events fire or the drawer opens. This is the bulletproof
        // piece: whatever state the drawer was in (empty after delete,
        // closed, already open), its DOM now matches the server's
        // actual cart state.
        if (cart && cart.sections) {
          try { wwInjectCartSections(cart); } catch(e) {}
        }

        var detail = { cart: cart, source: 'ww-pdp' };
        var events = [
          'cart:refresh','cart:updated','cart:change','cart:build',
          'cart-updated','cart:added','ajaxCart.afterCartLoad',
          'ajaxProduct.afterAtc','product:added','product:added-to-cart'
        ];
        events.forEach(function(evt) {
          try { document.dispatchEvent(new CustomEvent(evt, { detail: detail, bubbles: true })); } catch(e) {}
          try { window.dispatchEvent(new CustomEvent(evt, { detail: detail })); } catch(e) {}
        });
        if (window.jQuery) {
          var $ = window.jQuery;
          events.forEach(function(evt) {
            try { $(document).trigger(evt, [cart]); } catch(e) {}
            try { $(document.body).trigger(evt, [cart]); } catch(e) {}
          });
        }
        try {
          if (window.Shopify && window.Shopify.PubSub && typeof window.Shopify.PubSub.publish === 'function') {
            window.Shopify.PubSub.publish('cart-update', detail);
            window.Shopify.PubSub.publish('cart:update', detail);
          }
        } catch(e) {}

        var opened = false;
        var openerAttempts = [
          function(){ if (window.MonsterCart       && typeof window.MonsterCart.open       === 'function'){ window.MonsterCart.open();       return true; } return false; },
          function(){ if (window.monsterCart       && typeof window.monsterCart.open       === 'function'){ window.monsterCart.open();       return true; } return false; },
          function(){ if (window.MonsterCartDrawer && typeof window.MonsterCartDrawer.open === 'function'){ window.MonsterCartDrawer.open(); return true; } return false; },
          function(){ if (window.SlideCart         && typeof window.SlideCart.open         === 'function'){ window.SlideCart.open();         return true; } return false; },
          function(){ if (window.CartDrawer        && typeof window.CartDrawer.open        === 'function'){ window.CartDrawer.open();        return true; } return false; },
          function(){ if (window.qikifySlideCart   && typeof window.qikifySlideCart.open   === 'function'){ window.qikifySlideCart.open();   return true; } return false; },
          function(){ if (typeof window.openCartDrawer === 'function'){ window.openCartDrawer(); return true; } return false; },
          function(){ if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function'){ window.theme.cart.open(); return true; } return false; }
        ];
        for (var i = 0; i < openerAttempts.length; i++) {
          try { if (openerAttempts[i]() === true) { opened = true; break; } } catch(e) {}
        }

        if (!opened) {
          var el = document.querySelector(
            'monster-cart-drawer, monster-cart, cart-drawer, cart-notification, ' +
            '#CartDrawer, #cart-drawer, #MonsterCartDrawer, ' +
            '.cart-drawer, .monster-cart-drawer, .monster-cart, [data-cart-drawer]'
          );
          if (el) {
            if (typeof el.open === 'function') { try { el.open(); opened = true; } catch(e) {} }
            if (!opened) { try { el.classList.add('active','is-open','open','drawer--is-open','mc-open'); opened = true; } catch(e) {} }
          }
        }

        function isDrawerAlreadyOpen() {
          if (document.body.classList.contains('mc-open') ||
              document.body.classList.contains('cart-open') ||
              document.body.classList.contains('drawer-open') ||
              document.body.classList.contains('cart-drawer-open') ||
              document.body.classList.contains('overflow-hidden')) return true;
          var drawers = document.querySelectorAll(
            'monster-cart-drawer, monster-cart, cart-drawer, ' +
            '.monster-cart-drawer, .cart-drawer, [data-cart-drawer]'
          );
          for (var d = 0; d < drawers.length; d++) {
            var dr = drawers[d];
            if (dr.classList.contains('is-open') ||
                dr.classList.contains('open') ||
                dr.classList.contains('active') ||
                dr.classList.contains('drawer--is-open') ||
                dr.classList.contains('mc-open') ||
                dr.getAttribute('open') === 'true' ||
                dr.getAttribute('aria-hidden') === 'false') {
              return true;
            }
          }
          return false;
        }
        if (!opened && isDrawerAlreadyOpen()) opened = true;

        if (!opened) {
          var candidates = document.querySelectorAll(
            '[data-open-cart-drawer], [data-cart-drawer-trigger], ' +
            '[data-action="open-drawer"], [data-action="open-cart"], ' +
            '.js-drawer-open-right-cart, .js-cart-drawer-open, ' +
            '.monster-cart-trigger, [data-monster-cart-open], ' +
            '.header__cart-icon, .header__icon--cart, .site-header__cart, ' +
            'a[href="/cart"], a[href$="/cart"]'
          );
          var visibleTrigger = null;
          for (var c = 0; c < candidates.length; c++) {
            var node = candidates[c];
            var rect = node.getBoundingClientRect();
            if (rect.width > 0 && rect.height > 0) {
              var cs = window.getComputedStyle ? window.getComputedStyle(node) : null;
              if (!cs || (cs.display !== 'none' && cs.visibility !== 'hidden')) {
                visibleTrigger = node; break;
              }
            }
          }
          var trigger = visibleTrigger || candidates[0];
          if (trigger) {
            try {
              var ev = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
              trigger.dispatchEvent(ev);
              opened = true;
            } catch(e) {
              try { trigger.click(); opened = true; } catch(e2) {}
            }
          }
        }

        // Legacy badge update — belt-and-suspenders in case none of the
        // events above hit a listener that updates the header count.
        try { wwUpdateCartBadge(); } catch(e) {}
      });
  }

  function wwBindMainAtcForm() {
    var form = document.querySelector('form[id^="ww-product-form-"]');
    if (!form) return;
    if (form.__wwAtcBound) return;
    form.__wwAtcBound = true;

    form.addEventListener('submit', function(e) {
      // If an accelerated checkout button did this (Shop Pay etc.),
      // let the native flow run — those don't hit /cart/add.
      if (e.submitter && e.submitter.name === 'checkout') return;

      // preventDefault stops the browser from navigating away on native
      // form submission. Critical — without this, clicking ATC would
      // redirect the shopper to /cart. Stays on page regardless of how
      // Monster Upsells is handling the actual cart add.
      e.preventDefault();

      // CRITICAL BUG FIX (2026-04-24):
      // On gowacky.us, Monster Upsells has its OWN submit listener on
      // this form. That listener fires independently of ours — both
      // listeners fire on every click (preventDefault only stops the
      // browser's native navigation, not other listeners on the event).
      // If we ALSO call /cart/add.js or monster_addToCart() in here,
      // the cart receives TWO adds per click. Double-add bug.
      //
      // Fix: this handler does NOTHING but preventDefault + UI feedback.
      // Monster Upsells's own listener owns the single cart add.
      //
      // Historical context: earlier versions of this handler tried
      // fetch('/cart/add.js') (which MU was also doing in parallel, so
      // double-add) and later tried monster_addToCart() (which MU was
      // also doing in parallel via submit intercept, so still double-add).
      // The correct pattern is to LET MU OWN THE ADD ENTIRELY and only
      // handle our own UI state here.
      //
      // If Monster Upsells is ever uninstalled, this handler will no
      // longer add to cart and we'd need to add a `if (!window.monster_addToCart)`
      // fallback. Not likely given how deeply MU is integrated into the
      // store, but noting for future maintenance.

      var btn = document.querySelector('.ww-cta-main');
      if (btn) {
        var origLabel = btn.textContent;
        btn.textContent = 'Adding\u2026';
        btn.disabled = true;
        // Give MU ~1.2s to complete its add + drawer animation, then
        // flip to "Added ✓", then restore the price label.
        setTimeout(function() {
          btn.textContent = 'Added \u2713';
          setTimeout(function() {
            btn.textContent = origLabel;
            btn.disabled = false;
          }, 1200);
        }, 1200);
      }
    }, false);
  }


  /* ──────────────────────────────────────────────────────────────
     PROJECT PLAY IT FORWARD — donation widget
     Mirrors WUNDERball's initDonation (ww-wunderball.js), with
     .ww-don-* class prefixes and WW_DONATION config instead of
     WB_DONATION. Handles one-time + recurring, qty stepper,
     selling-plan auto-discovery, and Monster Cart drawer refresh.
     ────────────────────────────────────────────────────────────── */
  function wwMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }
  function wwResolvePlanId(cfg, interval) {
    var sub = cfg.subscription || {};
    var explicit = (sub.selling_plan_ids || {})[String(interval)];
    if (explicit) return explicit;
    var plans = sub.plans || [];
    if (!plans.length) return null;
    var want = String(interval);
    for (var i = 0; i < plans.length; i++) {
      var h = ((plans[i].name || '') + ' ' + (plans[i].description || '')).toLowerCase();
      if (new RegExp('\\b' + want + '\\s*(day|days|d)\\b').test(h)) return plans[i].id;
      if (new RegExp('every\\s+' + want + '\\b').test(h))          return plans[i].id;
    }
    var monthKw = { '30':['monthly','month'], '60':['bi-monthly','bimonthly','2 month','two month'] };
    var kws = monthKw[want] || [];
    for (var j = 0; j < plans.length; j++) {
      var hh = ((plans[j].name || '') + ' ' + (plans[j].description || '')).toLowerCase();
      for (var k = 0; k < kws.length; k++) { if (hh.indexOf(kws[k]) !== -1) return plans[j].id; }
    }
    var idxMap = { '30':0, '60':1 };
    if (plans[idxMap[want]]) return plans[idxMap[want]].id;
    return null;
  }
  function wwInitPlayItForward() {
    /* ────────────────────────────────────────────────────────────
       MOBILE-SAFE PORT (v3 2026-04-24 evening)
       1-for-1 mirror of ww-wunderball.js initDonation() which is
       confirmed working on iOS. Two structural changes vs the prior
       version that was broken on mobile:

       1. Removed the `widget = getElementById('ww-donate-widget'); if
          (!widget) return;` early bailout. The WUNDERball version
          doesn't have it; that early bailout was likely returning
          before listeners attached on mobile if the widget element
          rendered later than DOMContentLoaded. The $q + $btn null
          check below is sufficient safety.

       2. Switched all `.ww-don-freq-btn` and `.ww-don-interval-opt`
          queries from scoped (`widget.querySelectorAll`) to global
          (`document.querySelectorAll`). On mobile, scoped queries
          can return empty even when the buttons exist if there's
          any rendering quirk between widget element and its child
          buttons. Global queries find them regardless. This matches
          the proven-working WUNDERball pattern exactly.
       ──────────────────────────────────────────────────────────── */
    var cfg = window.WW_DONATION || {};
    var UNIT_ONCE    = (cfg.onetime && cfg.onetime.price) || 1299;
    var UNIT_MONTHLY = (cfg.subscription && cfg.subscription.price) || UNIT_ONCE;
    var state = { freq: 'onetime', qty: 1, interval: 30, adding: false };

    /* Read initial state from DOM so a hosting section can customize defaults
       without duplicating init logic. The standalone PPIF page
       (ww-play-it-forward-page.liquid) ships with .on on the recurring
       button to default the widget to subscription; per-PDP widgets leave
       .on on the one-time button and inherit the hardcoded default. */
    var initFreq = document.querySelector('.ww-don-freq-btn.on');
    if (initFreq && initFreq.dataset && initFreq.dataset.freq) {
      state.freq = initFreq.dataset.freq;
    }
    var initInt = document.querySelector('.ww-don-interval-opt.on');
    if (initInt && initInt.dataset && initInt.dataset.int) {
      var parsedInt = parseInt(initInt.dataset.int, 10);
      if (parsedInt > 0) state.interval = parsedInt;
    }

    var $q    = document.getElementById('ww-don-qty');
    var $sub  = document.getElementById('ww-don-qty-sub');
    var $tot  = document.getElementById('ww-don-total');
    var $tsub = document.getElementById('ww-don-total-sub');
    var $btn  = document.getElementById('ww-don-btn');
    var $note = document.getElementById('ww-don-btn-note');
    var $int  = document.getElementById('ww-don-interval');
    var $dec  = document.getElementById('ww-don-dec');
    var $inc  = document.getElementById('ww-don-inc');
    if (!$q || !$btn) return;

    function paint() {
      var qty = state.qty;
      var unit = state.freq === 'monthly' ? UNIT_MONTHLY : UNIT_ONCE;
      var total = unit * qty;
      var matched = qty * 2;
      $q.textContent = qty;
      $sub.textContent = '= ' + matched + (matched === 1 ? ' ball' : ' balls') + ' delivered (1:1 match)';
      $tot.textContent = wwMoney(total);
      $dec.disabled = qty <= 1;
      $inc.disabled = qty >= 20;

      if (state.freq === 'monthly') {
        $int.classList.add('show');
        $tsub.textContent = 'Every ' + state.interval + ' days · recurring donation';
        $btn.textContent  = 'Donate ' + qty + ' Every ' + state.interval + ' days — ' + wwMoney(total);
        $note.innerHTML   = 'Skip, reschedule, or cancel anytime in your account. <a href="#" data-ww-open-recharge-modal>How it works</a>';
      } else {
        $int.classList.remove('show');
        $tsub.textContent = qty > 1 ? 'One-time · ' + qty + ' balls' : 'One-time donation';
        $btn.textContent  = 'Donate ' + qty + ' Now — ' + wwMoney(total);
        $note.innerHTML   = '100% of balls ship to our Shelter Partners.';
      }
    }

    document.querySelectorAll('.ww-don-freq-btn').forEach(function(b) {
      b.addEventListener('click', function() {
        document.querySelectorAll('.ww-don-freq-btn').forEach(function(x) {
          x.classList.remove('on'); x.setAttribute('aria-selected','false');
        });
        b.classList.add('on'); b.setAttribute('aria-selected','true');
        state.freq = b.dataset.freq;
        paint();
      });
    });
    document.querySelectorAll('.ww-don-interval-opt').forEach(function(b) {
      b.addEventListener('click', function() {
        document.querySelectorAll('.ww-don-interval-opt').forEach(function(x) { x.classList.remove('on'); });
        b.classList.add('on');
        state.interval = parseInt(b.dataset.int, 10) || 30;
        paint();
      });
    });
    $dec.addEventListener('click', function() { if (state.qty > 1)  { state.qty--; paint(); } });
    $inc.addEventListener('click', function() { if (state.qty < 20) { state.qty++; paint(); } });

    $btn.addEventListener('click', function() {
      if (state.adding) return;
      var item;
      if (state.freq === 'monthly') {
        var sub = cfg.subscription || {};
        if (!sub.variant_id) {
          window.location.href = '/pages/donate-a-wunderball'; return;
        }
        var planId = wwResolvePlanId(cfg, state.interval);
        if (planId) {
          item = { id: sub.variant_id, quantity: state.qty, selling_plan: planId };
        } else {
          console.warn('[ww-pdp] no selling plan matched interval=' + state.interval + '. Adding as one-time.');
          item = { id: (cfg.onetime && cfg.onetime.variant_id) || sub.variant_id, quantity: state.qty };
          if ($note) {
            $note.innerHTML = 'Added as a one-time donation — recurring plans aren\u2019t configured yet. <a href="/pages/donate-a-wunderball">Set up recurring</a>';
          }
        }
      } else {
        var once = cfg.onetime || {};
        if (!once.variant_id) {
          window.location.href = '/pages/donate-a-wunderball'; return;
        }
        item = { id: once.variant_id, quantity: state.qty };
      }

      state.adding = true;
      $btn.disabled = true;
      var orig = $btn.textContent; $btn.textContent = 'Adding\u2026';

      // Monster UPSELLS API — the ONLY thing that actually refreshes
      // and opens the cart drawer on gowacky.us. See HANDOFF §7.6.
      // Dawn's Section Rendering API / fetch hooks / PubSub events
      // are all overridden by Monster Upsells and will NOT work.
      // window.monster_addToCart returns a promise that resolves after
      // MU has added the item, refreshed its drawer contents, and opened
      // the drawer. If MU isn't loaded (shouldn't happen in production
      // but be defensive), fall back to plain fetch — the shopper still
      // gets their item, they just miss the auto-drawer.
      var onSuccess = function() {
        $btn.textContent = 'Donation added \u2713';
        $btn.classList.add('ww-don-btn--added');
        setTimeout(function() {
          $btn.textContent = orig;
          $btn.classList.remove('ww-don-btn--added');
          $btn.disabled = false;
          state.adding = false;
        }, 2200);
        try { wwUpdateCartBadge(); } catch(e) {}
      };
      var onFail = function(err) {
        console.error('[ww-pdp] donation add failed:', err);
        alert('Could not add the donation. Please try again.');
        $btn.textContent = orig; $btn.disabled = false; state.adding = false;
      };

      var muAdd = window.monster_addToCart || window.monster_atc;
      if (typeof muAdd === 'function') {
        var muPayload = { id: item.id, quantity: item.quantity };
        if (item.selling_plan) muPayload.selling_plan = item.selling_plan;
        Promise.resolve(muAdd(muPayload)).then(onSuccess).catch(onFail);
      } else {
        // Fallback — no Monster Upsells. Use fetch + FormData (the
        // pattern that at least works for the main ATC form) and our
        // home-rolled drawer refresh.
        var fd = new FormData();
        fd.append('form_type', 'product');
        fd.append('utf8', '\u2713');
        fd.append('id', item.id);
        fd.append('quantity', item.quantity);
        if (item.selling_plan) fd.append('selling_plan', item.selling_plan);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
          credentials: 'same-origin'
        })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(er) { throw er; });
          return r.json();
        })
        .then(function() {
          onSuccess();
          try { wwRefreshAndOpenCartDrawer(); } catch(e) {}
        })
        .catch(onFail);
      }
    });

    paint();
  }


  /* ══════════════════════════════════════════════════════════════
     8b. MONSTER CART DISCOUNT SYNC  (v1  2026-07-16)
     ══════════════════════════════════════════════════════════════

     WHY THIS EXISTS
     ---------------
     Klaviyo email CTAs pass discount codes via `?discount=CODE`
     query string (e.g. Winback COMEBACK15, Cart FETCHBACK15, Browse
     PACKPICK10, Post-Purchase PACKGEAR10, Birthday BIRTHDAY40).
     Shopify applies the code to the cart session server-side, but
     Monster Upsells' drawer renders from cached HTML that doesn't
     know about the discount. Customer sees pre-discount subtotal
     in the drawer — checkout charges the right amount, but the
     drawer mismatch feels broken and drives abandonment.

     WHAT IT DOES
     ------------
     1. On page load, detects `?discount=` in the URL and calls
        /cart.js to confirm the discount landed on session. Logs
        for debugging; keeps a global flag for downstream helpers.

     2. Wraps window.monster_addToCart / monster_atc so every ATC
        completion triggers wwRefreshAndOpenCartDrawer, which
        re-fetches sections (including discount-aware markup) and
        re-injects them into the drawer container.

     3. Adds MutationObservers on body + drawer elements so ANY
        drawer-opening path (Monster's own binding, header cart
        icon click, our own opener, etc.) triggers a fresh
        section fetch + inject before the drawer paints.

     WHY THIS PATTERN
     ----------------
     Extends the proven wwInjectCartSections + wwRefreshAndOpenCartDrawer
     helpers (already in this file) rather than reinventing. Uses closure
     access — no globals exposed. Additive only — no existing code paths
     modified. Rollback is a single-block delete.

     TESTING (each flow, once):
     [ ] Winback COMEBACK15    — click email CTA, add to cart, verify discount line in drawer
     [ ] Abandoned Cart FETCHBACK15
     [ ] Browse Abandonment PACKPICK10
     [ ] Post-Purchase PACKGEAR10
     [ ] Dog Birthday BIRTHDAY40
     [ ] No-discount ATC still works (regression check)
     [ ] Double-add regression check per §6.1 — ATC should still be single-add
     ══════════════════════════════════════════════════════════════ */

  function wwInitMonsterCartDiscountSync() {
    // Guard against double-init on hot-reload or if wwPolishReady fires twice
    if (window.__wwMcdsInit) return;
    window.__wwMcdsInit = true;

    var DEBUG = false;  // Set true to console-log every step during QA
    function log() {
      if (!DEBUG || !window.console) return;
      try { console.log.apply(console, ['[ww-mcds]'].concat([].slice.call(arguments))); } catch(e) {}
    }

    /* ---- A. Detect ?discount= on page load ---- */
    function detectSessionDiscount() {
      var params;
      try { params = new URLSearchParams(window.location.search); }
      catch(e) { return; }
      var code = params.get('discount');
      if (!code) return;

      log('URL discount detected:', code, '— confirming with /cart.js');
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(cart) {
          if (!cart) return;
          window.__wwSessionDiscount = {
            code: code,
            total_discount: cart.total_discount || 0,
            has_applications: (cart.cart_level_discount_applications || []).length > 0
          };
          log('Session cart state:', window.__wwSessionDiscount);
        })
        .catch(function() {});
    }

    /* ---- B. Refresh drawer contents (no open) ----
       Lightweight variant of wwRefreshAndOpenCartDrawer — only
       refreshes section HTML, skips the opener attempts. Called
       when the drawer is already opening (via Monster) and we
       just want its content to be up-to-date. */
    function refreshDrawerContents() {
      var sectionList = [
        'cart-drawer', 'monster-cart', 'monster-cart-drawer',
        'cart-notification', 'cart-icon-bubble', 'cart'
      ];
      var presentSections = sectionList.filter(function(k) {
        return document.querySelector(
          '#shopify-section-' + k + ', [data-section-id="' + k + '"], [data-section="' + k + '"]'
        );
      });
      var fetchUrl = presentSections.length
        ? '/cart.js?sections=' + encodeURIComponent(presentSections.join(','))
        : '/cart.js';

      return fetch(fetchUrl, { credentials: 'same-origin', cache: 'no-store' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(cart) {
          if (!cart) return;
          if (cart.sections) {
            try { wwInjectCartSections(cart); } catch(e) {}
            log('Sections refreshed. total_discount:', cart.total_discount || 0);
          }
          try { wwUpdateCartBadge(); } catch(e) {}
          return cart;
        })
        .catch(function() { return null; });
    }
    // Expose so other modules (Play It Forward, FBT) can call it if needed
    window.wwRefreshDrawerContents = refreshDrawerContents;

    /* ---- C. Wrap Monster's ATC with a post-add refresh ----
       Every Monster ATC completion triggers a section refetch +
       inject. Retries for up to ~10s in case MU loads late. */
    function wrapMonsterAtc() {
      var attempts = 0;
      var maxAttempts = 40;

      function tryWrap() {
        attempts++;
        var muAdd = window.monster_addToCart || window.monster_atc;
        if (typeof muAdd !== 'function') {
          if (attempts < maxAttempts) return setTimeout(tryWrap, 250);
          log('Monster ATC not present after ' + maxAttempts + ' attempts. Skipping wrap.');
          return;
        }
        if (muAdd.__wwWrapped) { log('Monster ATC already wrapped'); return; }

        var original = muAdd;
        var wrapped = function() {
          log('Monster ATC called');
          var result;
          try { result = original.apply(this, arguments); }
          catch(e) {
            // Even if MU throws, still refresh in case it partial-succeeded
            setTimeout(function() { try { refreshDrawerContents(); } catch(e) {} }, 400);
            throw e;
          }
          if (result && typeof result.then === 'function') {
            result.then(function(v) {
              try { refreshDrawerContents(); } catch(e) {}
              return v;
            }, function(err) {
              // Refresh even on rejection — cart state may still have changed
              try { refreshDrawerContents(); } catch(e) {}
              return Promise.reject(err);
            });
          } else {
            // Non-promise return — best-effort delayed refresh
            setTimeout(function() { try { refreshDrawerContents(); } catch(e) {} }, 500);
          }
          return result;
        };
        wrapped.__wwWrapped = true;

        if (window.monster_addToCart === original) window.monster_addToCart = wrapped;
        if (window.monster_atc === original)       window.monster_atc = wrapped;
        log('Monster ATC wrapped');
      }
      tryWrap();
    }

    /* ---- D. MutationObserver on drawer open ----
       Whatever code path opens the drawer (Monster's own binding,
       header cart icon, our opener, etc.), a class change triggers
       a debounced refresh. Debounce prevents rapid re-fetches
       during the class-toggle sequence. */
    function observeDrawerOpen() {
      if (!('MutationObserver' in window)) return;

      var OPENING_BODY_CLASSES = ['mc-open','cart-open','drawer-open','cart-drawer-open'];
      var OPENING_EL_CLASSES   = ['is-open','open','active','drawer--is-open','mc-open'];
      var DRAWER_SELECTORS = 'monster-cart, monster-cart-drawer, cart-drawer, ' +
                             '.monster-cart, .monster-cart-drawer, .cart-drawer, ' +
                             '[data-cart-drawer]';

      var lastRefresh = 0;
      function debouncedRefresh(source) {
        var now = Date.now();
        if (now - lastRefresh < 300) return;
        lastRefresh = now;
        log('Drawer opening (via ' + source + '); refreshing');
        try { refreshDrawerContents(); } catch(e) {}
      }

      function isOpeningByBodyClasses() {
        return OPENING_BODY_CLASSES.some(function(c) { return document.body.classList.contains(c); });
      }

      // Body class observer
      try {
        var bodyObs = new MutationObserver(function(muts) {
          for (var i = 0; i < muts.length; i++) {
            if (muts[i].attributeName === 'class' && isOpeningByBodyClasses()) {
              debouncedRefresh('body-class');
              return;
            }
          }
        });
        bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      } catch(e) { log('body observer failed', e); }

      // Drawer element observers — attach now AND on future insertions
      function attachDrawerObservers() {
        document.querySelectorAll(DRAWER_SELECTORS).forEach(function(el) {
          if (el.__wwDrawerObserved) return;
          el.__wwDrawerObserved = true;
          try {
            var obs = new MutationObserver(function(muts) {
              for (var i = 0; i < muts.length; i++) {
                var m = muts[i];
                if (m.attributeName === 'class' || m.attributeName === 'open' || m.attributeName === 'aria-hidden') {
                  var opening =
                    OPENING_EL_CLASSES.some(function(c) { return el.classList.contains(c); }) ||
                    el.getAttribute('open') === 'true' ||
                    el.getAttribute('aria-hidden') === 'false';
                  if (opening) { debouncedRefresh('drawer-el-attr'); return; }
                }
              }
            });
            obs.observe(el, { attributes: true, attributeFilter: ['class','open','aria-hidden'] });
          } catch(e) {}
        });
      }
      attachDrawerObservers();

      // Watch for drawer elements being inserted later (Monster loads async)
      try {
        var insertObs = new MutationObserver(function() { attachDrawerObservers(); });
        insertObs.observe(document.body, { childList: true, subtree: true });
        // Give Monster ~10s to inject its drawer, then stop watching for insertions
        setTimeout(function() { try { insertObs.disconnect(); } catch(e) {} }, 10000);
      } catch(e) {}

      log('Drawer open observers armed');
    }

    /* ---- E. Init ---- */
    detectSessionDiscount();
    wrapMonsterAtc();
    observeDrawerOpen();
    log('Monster Cart Discount Sync initialized');
  }


  /* ----------------------------------------------------------
     8. INIT ON DOM READY
     ---------------------------------------------------------- */
  function wwPolishReady() {
    wwInitScrollReveal();
    wwPatchFbtFooter();
    wwPatchGuarantee();
    wwPatchFeatures();
    wwPatchComparisonTable();
    wwPatchFaq();
    wwRelocateShopPay();
    wwApplyStrikethrough();
    wwPatchAtcPrice();
    wwPatchTreatsFbt();
    // wwBindMainAtcForm();  // DISABLED 2026-04-24 — Monster Upsells intercepts ATC submit independently, this caused double-adds. See HANDOFF §6.1.
    wwInitPlayItForward();
    wwInitMonsterCartDiscountSync();  // NEW 2026-07-16 — sync ?discount= codes with Monster Cart drawer
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wwPolishReady);
  } else {
    wwPolishReady();
  }

})();